/* ═══════════════════════════════════════════════════════════════════════════
   OBRAH · PDP 2026 — o controlador da coluna
   (c) 2026 Obrah. Proprietary and confidential.

   Fonte da verdade: Paper "Jolly kale" — `1F2G-0` (desktop), `1FYQ-0` (mobile),
   `1GYT-0` (barra fixa). Spec: docs/pdp-2026-coluna-spec-01ago.md.

   ═══ O QUE ESTE ARQUIVO NÃO FAZ ═══
   Não monta marcação. A coluna inteira já veio pronta do servidor
   (snippets/pdp2026-coluna.liquid). Aqui só se mantêm VIVOS os valores que
   dependem da escolha: o valor à direita de cada bloco, o tamanho final, o
   preço, o PIX e a barra do mobile.

   Também não fala com o palco. Quem troca a moldura na foto é o evento
   `product:variant-change` que o `<variant-selects>` do tema dispara sozinho
   quando um radio muda — o motor de moldura, o ambientado e a escada de
   tamanhos continuam intocados.

   ═══ POR QUE SÓ A MOLDURA PRECISA DE JS ═══
   Cor e Tamanho são `<label for>` ligados ao radio: o navegador resolve.
   A Moldura não, porque "Padrão" não é um valor — é SEIS, dependendo dos
   Extras (padrão, padrão com paspatur, caixa, caixa com paspatur, slim, slim
   com paspatur). A tabela abaixo é a mesma do jun26.js, de propósito: ela é
   dado do catálogo, não lógica desta coluna, e as duas não podem divergir.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  var col = raiz.querySelector('[data-pdp26-col]');
  var vs = raiz.querySelector('variant-selects');
  if (!col || !vs) return;

  /* ─── tabelas ───────────────────────────────────────────────────────────
     primario|profundidade|fino|paspatur → o valor real da option1.
     Espelha VARIANT_MAP do jun26.js. */
  var COMBO = {
    'canvas|0|0|0': 'canvas',
    'sem moldura|0|0|0': 'sem moldura',
    'padrão|0|0|0': 'padrão',
    'padrão|0|0|1': 'padrão com paspatur',
    'padrão|1|0|0': 'caixa',
    'padrão|1|0|1': 'caixa com paspatur',
    'padrão|0|1|0': 'slim',
    'padrão|0|1|1': 'slim com paspatur'
  };
  /* o caminho de volta: do valor real pro estado */
  var ESTADO_DE = {};
  Object.keys(COMBO).forEach(function (k) {
    var p = k.split('|');
    ESTADO_DE[COMBO[k]] = { primario: p[0], profundidade: p[1] === '1', fino: p[2] === '1', paspatur: p[3] === '1' };
  });

  /* a face da moldura em cm, por peça — é o que entra na conta do tamanho
     final. Mesmos números do jun26.js (BORDER_CM), pelo mesmo motivo da
     tabela acima: é medida de produto, não decisão de layout. */
  var FACE_CM = { 'canvas': 1.5, 'padrão': 2, 'sem moldura': 0 };
  var PASPATUR_CM = 5;
  var FACE_SLIM = 0.7;

  var NOME = { 'canvas': 'Canvas', 'padrão': 'Padrão', 'sem moldura': 'Impressão' };
  var SUB = { 'canvas': 'sem vidro', 'padrão': 'com vidro', 'sem moldura': 'sem moldura' };
  var FICHA = {
    'canvas': 'Tela sobre chassi de madeira maciça, moldura flutuante sem vidro. Acompanha kit de instalação.',
    'padrão': 'Moldura em madeira maciça com vidro de 2 mm e fundo em MDF. Acompanha kit de instalação.',
    'sem moldura': 'Impressão em papel Canson® Satin 240 g/m², enviada enrolada em tubo, sem moldura.'
  };
  var PERFIL = {
    'madeira escura': '#6B5340',
    'preta': '#141414',
    'madeira clara': '#C9A876',
    'branca': '#FBFAF8'
  };
  /* (6/ago) nomes da V2 do Paper: o material no nome ("Paspatur branco"),
     o ganho em número ("3 cm de profundidade"). O "moldura caixa" saiu do
     nome e mora na DESCRIÇÃO (martelo do dono: "curti embaixo"). No subtítulo
     do card entra o nome CURTO quando existir ("Paspatur", sem o branco). */
  var EXTRA_NOME = {
    'paspatur': 'Paspatur',
    'profundidade': '3 cm de profundidade',
    'fino': 'Moldura slim'
  };
  /* no subtítulo do card, a profundidade escolhida fala pelo RESULTADO:
     "Caixa" — o número já cumpriu o papel na hora de escolher, e a palavra
     "Moldura" na frente inchava a linha (6/ago) */
  var EXTRA_CURTO = {
    'profundidade': 'Caixa'
  };
  /* 3/ago (P26·32/F4): cada extra ganha UMA linha dizendo o que ele é — a
     descrição à vista é quem vende; ⓘ ficou pra definição, não persuasão.
     O   prende as duas últimas palavras: sem viúva na quebra. */
  var EXTRA_DESC = {
    'paspatur': 'Adiciona margem branca de 5 cm para cada lado da arte.',
    'profundidade': 'Moldura caixa, mais profunda. Presença de galeria.',
    'fino': 'Perfil mais fino, presença discreta.'
  };

  /* o PIX vem do mesmo rótulo que o resto do site lê, pra não haver dois
     descontos diferentes na mesma página */
  var pixPct = 10;
  var pixLbl = document.querySelector('.obrah-pix-discount-label');
  var pixM = pixLbl && pixLbl.textContent.match(/(\d+)\s*%/);
  if (pixM) pixPct = parseInt(pixM[1], 10);

  /* (8/ago) o número de parcelas sem juros vem do que o servidor JÁ escreveu na
     linha do cartão — mesma técnica do PIX acima. Assim `settings.parceQt` mora
     num lugar só: se mudar no admin, o Liquid e o JS mudam juntos, sem número
     repetido no arquivo. Leitura feita antes de qualquer escrita. */
  var PARCE_QT = 3;
  var parcEl = document.querySelector('[data-pdp26-valor="parcela"]');
  var parcM = parcEl && parcEl.textContent.match(/(\d+)\s*x/);
  if (parcM) PARCE_QT = parseInt(parcM[1], 10) || 3;

  /* ─── o catálogo, lido uma vez ──────────────────────────────────────────
     O JSON já está na página (o `variant-selects` o usa). Ler daqui em vez de
     buscar na rede é o que faz o preço trocar no mesmo frame do clique. */
  var variantes = [];
  try {
    variantes = JSON.parse(vs.querySelector('script[type="application/json"]').textContent) || [];
  } catch (e) { return; }

  var porChave = {};
  variantes.forEach(function (v) {
    porChave[v.options.join('|')] = v;
  });

  var fsMold = vs.querySelector('[data-index="option1"]');
  var fsCor = vs.querySelector('[data-index="option2"]');
  var fsTam = vs.querySelector('[data-index="option3"]');
  if (!fsMold || !fsCor || !fsTam) return;

  function radios(fs) { return Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')); }
  function marcado(fs) { var r = fs.querySelector('input:checked'); return r ? r.value : ''; }
  function marcar(fs, valor) {
    var achou = false;
    radios(fs).forEach(function (r) {
      var eh = r.value === valor;
      if (eh) achou = true;
      r.checked = eh;
    });
    return achou;
  }

  /* (16/out) VENDÁVEL, não só "available": o lançamento do 20x20 e do 100x140
     acontece produto a produto, enquanto o cadastro é atualizado — e a
     variante ainda não precificada carrega preço-fantasma (R$ 9.999, ou zero).
     Ela não é oferta: some do mesmo jeito que uma variante que não existe.
     O 20x20 sem moldura nunca é vendido, mesmo que ganhe preço. */
  function vendavel(v) {
    if (!v || !v.available) return false;
    var p = v.price;
    if (!(p > 0) || p === 99999 || p >= 999900) return false;
    var o = v.options || [];
    if (String(o[2] || '').replace(/\s/g, '').toLowerCase() === '20x20' && o[0] === 'sem moldura') return false;
    return true;
  }
  function existe(mold, cor, tam) {
    var v = porChave[[mold, cor, tam].join('|')];
    return vendavel(v) ? v : null;
  }

  /* ─── formatação ────────────────────────────────────────────────────────
     Centavos só quando existem: "R$ 597" e não "R$ 597,00". O zero à direita
     é ruído numa coluna onde o preço é o número que mais pesa. */
  function brl(centavos) {
    var n = Math.round(centavos) / 100;
    var s = n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (/,00$/.test(s)) s = s.slice(0, -3);
    return 'R$ ' + s;
  }
  function brlCheio(centavos) {
    return 'R$ ' + (Math.round(centavos) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ─── estado ────────────────────────────────────────────────────────────
     Não há estado paralelo guardado: ele é SEMPRE derivado dos radios. Assim
     não existe a classe de bug em que a tela mostra uma coisa e o formulário
     manda outra. */
  function lerEstado() {
    var e = ESTADO_DE[marcado(fsMold)] || { primario: 'canvas', profundidade: false, fino: false, paspatur: false };
    return {
      primario: e.primario,
      profundidade: e.profundidade,
      fino: e.fino,
      paspatur: e.paspatur,
      cor: marcado(fsCor),
      tamanho: marcado(fsTam)
    };
  }
  function chaveDe(e) {
    return e.primario + '|' + (e.profundidade ? 1 : 0) + '|' + (e.fino ? 1 : 0) + '|' + (e.paspatur ? 1 : 0);
  }

  /* a cor da última moldura escolhida: "Impressão" não tem cor e obriga a
     option2 a virar "sem moldura"; ao voltar pra uma moldura, a cor anterior
     precisa voltar junto, senão a pessoa perde a escolha por ter espiado a
     impressão */
  var ultimaCor = marcado(fsCor);
  if (ultimaCor === 'sem moldura') ultimaCor = 'madeira clara';

  /* ─── resolução ─────────────────────────────────────────────────────────
     Dado um estado desejado, encontra a combinação vendável mais próxima.
     A ordem de desistência é a mesma do jun26.js: primeiro o paspatur, depois
     o perfil fino, por último a profundidade — do acessório mais dispensável
     pro mais estrutural. */
  function resolver(alvo) {
    var e = {
      primario: alvo.primario,
      profundidade: alvo.profundidade,
      fino: alvo.fino,
      paspatur: alvo.paspatur
    };
    var cor = alvo.primario === 'sem moldura' ? 'sem moldura' : (alvo.cor || ultimaCor);
    var tam = alvo.tamanho;

    function ok(s) {
      var m = COMBO[chaveDe(s)];
      return m && existe(m, cor, tam);
    }

    if (!ok(e)) {
      ['paspatur', 'fino', 'profundidade'].forEach(function (k) {
        if (!ok(e) && e[k]) {
          var t = Object.assign({}, e); t[k] = false;
          if (ok(t)) e[k] = false;
        }
      });
    }
    /* "Padrão" sem a variante simples: alguns tamanhos grandes só existem em
       caixa, e nesse caso a profundidade entra sozinha em vez de a moldura
       inteira ficar indisponível */
    if (!ok(e) && e.primario === 'padrão' && !e.profundidade) {
      var comCaixa = Object.assign({}, e, { profundidade: true, fino: false });
      if (ok(comCaixa)) e = comCaixa;
    }
    /* último recurso: o primeiro tamanho vendável desta moldura, pra nunca
       terminar num estado sem variante nenhuma */
    if (!ok(e)) {
      var achou = null;
      radios(fsTam).forEach(function (r) {
        if (achou) return;
        var m = COMBO[chaveDe(e)];
        if (m && existe(m, cor, r.value)) achou = r.value;
      });
      if (achou) tam = achou;
    }

    return { mold: COMBO[chaveDe(e)] || 'canvas', cor: cor, tam: tam };
  }

  /* ─── aplicar ───────────────────────────────────────────────────────────
     Marca os três radios e dispara UM `change` só. Um por radio dispararia
     três recálculos do `variant-selects` (e três requisições de seção) pra uma
     única decisão da pessoa. */
  var aplicando = false;
  function aplicar(alvo) {
    var r = resolver(alvo);
    aplicando = true;
    marcar(fsMold, r.mold);
    marcar(fsCor, r.cor);
    marcar(fsTam, r.tam);
    aplicando = false;
    if (r.cor !== 'sem moldura') ultimaCor = r.cor;
    vs.dispatchEvent(new Event('change', { bubbles: true }));
    pintar();
  }

  /* ─── disponibilidade dos extras ────────────────────────────────────────
     Um extra só é oferecido se ele existe PARA ESTA cor e ESTE tamanho.
     Oferta morta é pior que ausência: a pessoa lê, entende que quer, tenta e
     não vai. */
  function extrasDisponiveis(e) {
    var cor = e.cor === 'sem moldura' ? ultimaCor : e.cor;
    var lista = [];
    ['paspatur', 'profundidade', 'fino'].forEach(function (k) {
      var t = Object.assign({}, e); t[k] = !t[k];
      if (k === 'profundidade' && t.profundidade) t.fino = false;
      if (k === 'fino' && t.fino) t.profundidade = false;
      var m = COMBO[chaveDe(t)];
      if (!m) return;
      var v = existe(m, cor, e.tamanho);
      var troca = null;
      if (!v && t[k]) {
        /* 25/set: "caixa com paspatur" não existe, mas a pessoa precisa VER os
           dois acabamentos — com a caixa marcada o paspatur continua na
           lista, e marcá-lo solta a caixa (e vice-versa). */
        var par = k === 'paspatur' ? 'profundidade' : (k === 'profundidade' ? 'paspatur' : null);
        if (par && t[par]) {
          var t2 = Object.assign({}, t); t2[par] = false;
          var m2 = COMBO[chaveDe(t2)];
          v = m2 ? existe(m2, cor, e.tamanho) : null;
          if (v) troca = par;
        }
      }
      if (!v) {
        /* 25/set: profundidade ligada que NÃO dá pra desligar = caixa
           estrutural do tamanho (o padrão simples não existe em 100x100).
           O card confessa em vez de sumir: fica marcado e travado, sem
           preço — a pessoa precisa ver que está levando caixa. */
        if (k === 'profundidade' && e.profundidade) lista.push({ chave: k, ativo: true, delta: null, travado: true });
        return;
      }
      var atual = existe(COMBO[chaveDe(e)], cor, e.tamanho);
      lista.push({
        chave: k,
        ativo: !!e[k],
        troca: troca,
        delta: atual ? v.price - atual.price : null
      });
    });
    return lista;
  }

  /* ─── pintar ────────────────────────────────────────────────────────────
     Um lugar só escreve na tela. Chamado depois de qualquer mudança, venha
     ela de um clique meu ou de um `<label for>` que o navegador resolveu. */
  var alvos = {};
  col.querySelectorAll('[data-pdp26-valor]').forEach(function (n) {
    var k = n.getAttribute('data-pdp26-valor');
    (alvos[k] = alvos[k] || []).push(n);
  });
  function escrever(chave, texto) {
    (alvos[chave] || []).forEach(function (n) { n.textContent = texto; });
  }
  /* (6/ago) o "no Pix" precisa de tag própria para receber o cinza — o valor
     fica em tinta com peso, a palavra recua para o mesmo tom do "em até 12x".
     Caixa baixa de propósito: "Pix" é nome, não sigla gritada — o desconto é
     condição permanente de pagamento, não promoção. */
  function escreverHTML(chave, html) {
    (alvos[chave] || []).forEach(function (n) { n.innerHTML = html; });
  }

  var blocoCor = col.querySelector('.pdp26-bloco--cor');
  var linhaExtras = col.querySelector('[data-pdp26-extras]');
  var corpoExtras = col.querySelector('[data-pdp26-extras-corpo]');
  var togExtras = col.querySelector('[data-pdp26-extras-toggle]');
  var tipMold = col.querySelector('[data-pdp26-tip="moldura"]');

  function pintar() {
    var e = lerEstado();
    var semMoldura = e.primario === 'sem moldura';

    /* miniaturas de moldura */
    col.querySelectorAll('[data-pdp26-primario]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-pdp26-primario') === e.primario));
    });

    /* o perfil dos glifos renderiza na COR ESCOLHIDA — as três miniaturas
       mostram a peça que está sendo comprada, não um genérico. A cor entra por
       CLASSE porque os quatro tons de cada madeira moram no CSS, do lado dos
       mesmos valores que o mini cart usa. */
    var corGl = (semMoldura ? ultimaCor : e.cor) || 'madeira clara';
    var fileira = col.querySelector('.pdp26-fileira--moldura');
    if (fileira) {
      ['madeira-escura', 'preta', 'madeira-clara', 'branca'].forEach(function (c) {
        fileira.classList.toggle('is-cor-' + c, c === corGl.replace(/\s+/g, '-'));
      });
    }

    /* valor à direita de cada bloco */
    var nome = NOME[e.primario] || e.primario;
    if (e.primario === 'padrão' && e.fino) nome = 'Slim';
    /* 3/ago: a profundidade REBATIZA — "Padrão" com caixa é Caixa, inclusive
       quando o GG+ a força (§caixa estrutural): o recibo tem que confessar */
    if (e.primario === 'padrão' && e.profundidade) nome = 'Caixa';
    escrever('moldura', nome + ' · ' + (SUB[e.primario] || ''));
    if (tipMold) tipMold.textContent = FICHA[e.primario] || '';

    if (blocoCor) blocoCor.hidden = semMoldura;
    escrever('cor', semMoldura ? '' : capitalizar(e.cor));

    /* tamanho final = arte + duas faces (+ dois paspaturs) */
    var d = medida(e.tamanho);
    if (d) {
      var face = e.fino ? FACE_SLIM : (FACE_CM[e.primario] != null ? FACE_CM[e.primario] : 2);
      var somaLado = face + (e.paspatur ? PASPATUR_CM : 0);
      escrever('final', Math.round(d.w + 2 * somaLado) + ' × ' + Math.round(d.h + 2 * somaLado) + ' cm');
    } else {
      escrever('final', '—');
    }

    /* preço, PIX e o resumo da barra */
    var v = porChave[[marcado(fsMold), marcado(fsCor), marcado(fsTam)].join('|')];
    if (v) {
      escrever('preco', brl(v.price));
      /* (6/ago) sem "no PIX": na ficha, a bandeira à esquerda já é o rótulo —
         a palavra repetia o símbolo na mesma linha. Fica só o valor. */
      escrever('pix', brlCheio(v.price * (100 - pixPct) / 100));
      /* (6/ago) o selo volta a ser "−10%" em pílula: com o PIX embaixo do preço
         e a palavra "no PIX" de volta, a linha já é longa — "10% de desconto"
         por extenso empurrava tudo. Aqui o sinal de menos não lê como
         liquidação porque está numa pílula sólida, encostado no valor que ele
         explica. O número vem vivo do pixPct (rótulo oficial do site), nunca
         fixo. Texto puro — o <b class="pdp26-pix__pct"> de 5/ago saiu porque
         o selo fala numa voz só (uma cor, um peso). */
      (alvos['pixoff'] || []).forEach(function (n) {
        /* (8/ago) "−10%" também aqui: com o parcelamento embaixo, a linha do PIX
           passou a ter três peças e a frase por extenso era a mais longa das
           três. Mesma forma da sacola — o site fala igual nos dois lugares. */
        n.textContent = '−' + pixPct + '%';
      });
      /* (8/ago) o parcelamento acompanha a variante: valor SÓ no que é sem juros
         (parceQt), pela mesma conta do Liquid — divisão inteira dos centavos. */
      escrever('parcela', PARCE_QT + 'x de ' + brl(Math.floor(v.price / PARCE_QT)));
      escrever('config', sigla(e.tamanho) + ' · ' + nome);
    }

    /* o rótulo da medida confessa o paspatur quando ele entra (3/ago); e a
       linha inteira some no "sem moldura" — o tamanho final ali é a própria
       arte, que a linha de cima já declara */
    /* 3/ago (P26·35/F): "Quadro pronto" — nome de coisa, não de conta. Absorve
       o paspatur sem inchar o rótulo; quem confessa o paspatur é a linha
       Moldura ("· paspatur"), e o ⓘ segue definindo. */
    /* (5/ago) "Arte + moldura CANVAS": o rótulo NOMEIA a moldura que entrou
       na conta. Sem o nome, a medida servia pra qualquer escolha e a pessoa
       tinha que lembrar qual estava marcada lá em cima; com ele, a célula
       fecha sozinha — e muda junto quando o Extras vira Caixa ou Slim.
       ("Ocupa na parede" e "Arte com moldura" foram as voltas anteriores.) */
    var nomeMold = nome;
    if (e.primario === 'padrão') {
      if (e.profundidade) nomeMold = 'Caixa';
      else if (e.fino) nomeMold = 'Slim';
    }
    /* (5/ago, forma final) OS RÓTULOS VIRAM FRASE, não fórmula:
         "Somente a arte"  ·  "Com moldura Canvas"  ·  "Com moldura Padrão e
         paspatur".
       A soma com "+" pedia que a pessoa fizesse a conta na cabeça; a frase
       só descreve o que ela vai receber. As duas células passam a se ler em
       par: o que é a arte sozinha, e o que ela vira montada. */
    /* (6/ago) rótulo FIXO: "Arte com a moldura" — pra todas as configurações.
       A soma ("Padrão + Paspatur") e a frase ("Com moldura Padrão e paspatur")
       ficaram pra trás: quem diz QUAL moldura e QUAIS acabamentos é a coluna
       logo acima (seletor + subtítulo do card), e o ⓘ avisa que a medida
       acompanha. O "a" aponta: a moldura que você escolheu. */
    escrever('final-rot', 'Arte com a moldura');
    var linhaFinal = col.querySelector('[data-pdp26-recibo-final]');
    if (linhaFinal) linhaFinal.hidden = semMoldura;
    /* (6/ago) o tooltip das DIMENSÕES FINAIS acompanha o acabamento: na
       "sem moldura" não existe quadro completo — a frase descreve a impressão
       que chega enrolada, pronta para emoldurar. */
    var tipDim = col.querySelector('[data-pdp26-tip-dim]');
    if (tipDim) {
      tipDim.textContent = semMoldura
        ? 'As medidas indicadas correspondem à impressão, sem moldura, exatamente como ela chegará à sua casa, pronta para ser emoldurada.'
        : 'As medidas indicadas correspondem ao quadro completo, já com a moldura, exatamente como ele chegará à sua casa.';
    }

    /* recibo do bloco de fechamento (3/ago) — mini-tabela com rótulos:
       Moldura (identidade + cor, com o swatch redondo de material),
       Arte (sigla + cm — bate 1:1 com o mini cart) e
       Tamanho com moldura (derivado; a chave `final` já escreve nele). */
    /* a cor fala pelo SWATCH; o texto fica com o tipo + a spec ("sem vidro") —
       decisão de 3/ago ao vivo: nome de cor por extenso aqui era too much */
    var rMold = nome + (SUB[e.primario] ? ' · ' + SUB[e.primario] : '');
    /* 3/ago: o paspatur também entra na linha Moldura — o rótulo "Arte +
       moldura + paspatur" anunciava, mas a linha da moldura ficava muda */
    if (e.paspatur) rMold += ' · paspatur';
    escrever('recibo-mold', rMold);
    /* sem a sigla: o chip logo acima já diz "GG"; aqui só o cm interessa */
    escrever('recibo-arte', d ? d.w + ' × ' + d.h + ' cm' : sigla(e.tamanho));
    var swRecibo = col.querySelector('[data-pdp26-recibo-sw]');
    if (swRecibo) {
      var corRecibo = semMoldura ? '' : (e.cor || '').replace(/\s+/g, '-');
      ['madeira-escura', 'preta', 'madeira-clara', 'branca'].forEach(function (c) {
        swRecibo.classList.toggle('pdp26-sw__mat--' + c, c === corRecibo);
      });
      swRecibo.hidden = semMoldura;
    }

    /* tamanho que não existe nesta combinação fica mais claro — a fileira não
       pode mentir que tudo é igual, mas o chip continua clicável porque clicar
       nele reconfigura os extras em vez de bater numa porta fechada */
    var corAtual = semMoldura ? 'sem moldura' : e.cor;
    radios(fsTam).forEach(function (r) {
      /* vivo = ALGUMA peça desta moldura existe neste tamanho, com ou sem os
         extras. Testar só a combinação atual apagaria o chip por causa de um
         paspatur que a própria troca de tamanho derrubaria. */
      var vivo = Object.keys(COMBO).some(function (k) {
        return k.indexOf(e.primario + '|') === 0 && existe(COMBO[k], corAtual, r.value);
      });
      r.classList.toggle('is-disabled', !vivo);
    });

    pintarExtras(e);
  }

  function pintarExtras(e) {
    if (!linhaExtras || !corpoExtras) return;
    var lista = e.primario === 'padrão' ? extrasDisponiveis(e) : [];
    linhaExtras.hidden = lista.length === 0;
    if (!lista.length) { corpoExtras.innerHTML = ''; return; }

    var ativos = lista.filter(function (x) { return x.ativo; }).map(function (x) { return EXTRA_CURTO[x.chave] || EXTRA_NOME[x.chave]; });
    /* (6/ago) o subtítulo SÓ existe quando há escolha — sem escolha, o título
       fala sozinho ("nnnao quero deixar nenhum selecionado"). Vazio, o CSS
       o esconde via :empty; com escolha, nomes curtos em tinta, embaixo. */
    escrever('extras', ativos.join(' · '));

    corpoExtras.innerHTML = '';
    lista.forEach(function (x) {
      var lb = document.createElement('label');
      lb.className = 'pdp26-extra';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = x.ativo;
      if (x.travado) { cb.disabled = true; lb.classList.add('is-travado'); }
      /* 3/ago (F4): check QUADRADO visível — o input segue oculto por cima
         da estilização, e este span é o desenho que o CSS pinta */
      var box = document.createElement('span');
      box.className = 'pdp26-extra__cb';
      var colTxt = document.createElement('span');
      colTxt.className = 'pdp26-extra__col';
      var n = document.createElement('span');
      n.className = 'pdp26-extra__n';
      n.textContent = EXTRA_NOME[x.chave];
      colTxt.appendChild(n);
      if (EXTRA_DESC[x.chave] || x.travado) {
        var d = document.createElement('span');
        d.className = 'pdp26-extra__d';
        /* travado: a descrição explica o PORQUÊ (estrutural), mesma frase
           do motor jun26, sem falar em preço */
        d.textContent = x.travado
          ? 'Já incluída neste tamanho para garantir maior estrutura e estabilidade ao quadro.'
          : EXTRA_DESC[x.chave];
        colTxt.appendChild(d);
      }
      var p = document.createElement('span');
      p.className = 'pdp26-extra__p';
      /* (6/ago) sem "incluído": ou o extra custa e mostra o acréscimo, ou cala */
      p.textContent = (x.delta != null && x.delta > 0) ? '+ ' + brl(x.delta) : '';
      lb.appendChild(cb); lb.appendChild(box); lb.appendChild(colTxt); lb.appendChild(p);
      cb.addEventListener('change', function () {
        var alvo = lerEstado();
        alvo[x.chave] = cb.checked;
        if (x.troca && cb.checked) alvo[x.troca] = false;   /* um solta o outro */
        if (x.chave === 'profundidade' && cb.checked) alvo.fino = false;
        if (x.chave === 'fino' && cb.checked) alvo.profundidade = false;
        aplicar(alvo);
      });
      corpoExtras.appendChild(lb);
    });
    /* (6/ago) rodapé ⓘ do card — o único pedaço cinza: responde "e o tamanho
       final?" no lugar onde a dúvida nasce, apontando pro bloco logo abaixo */
    var nota = document.createElement('div');
    nota.className = 'pdp26-extras__nota';
    nota.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="#74706A" stroke-width="1.3"/><path d="M12 11v5M12 7.6v.5" stroke="#74706A" stroke-width="1.4" stroke-linecap="round"/></svg>'
      + '<span>As dimensões finais são atualizadas de acordo com os acabamentos escolhidos.</span>';
    corpoExtras.appendChild(nota);
  }

  function medida(valor) {
    var m = String(valor || '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    return { w: parseFloat(m[1].replace(',', '.')), h: parseFloat(m[2].replace(',', '.')) };
  }
  var SIGLAS = {
    '25x35': 'PP', '30x42': 'P', '35x50': 'M', '50x70': 'G', '70x100': 'GG', '100x140': 'XG',
    '20x20': 'XP', '30x30': 'P', '50x50': 'M', '70x70': 'G', '100x100': 'XG'
  };
  function sigla(v) { return SIGLAS[String(v).replace(/\s/g, '').toLowerCase()] || String(v); }
  function capitalizar(s) { return String(s || '').charAt(0).toUpperCase() + String(s || '').slice(1); }

  /* ─── escutas ───────────────────────────────────────────────────────────*/

  /* a moldura: o único controle que precisa de tradução */
  col.querySelectorAll('[data-pdp26-primario]').forEach(function (b) {
    b.addEventListener('click', function () {
      var novo = b.getAttribute('data-pdp26-primario');
      var e = lerEstado();
      if (e.primario === novo) return;
      /* trocar de moldura zera os extras: eles pertencem à Padrão, e carregar
         um paspatur pra dentro do Canvas seria decidir por quem clicou */
      aplicar({
        primario: novo,
        profundidade: false, fino: false, paspatur: false,
        cor: novo === 'sem moldura' ? 'sem moldura' : ultimaCor,
        tamanho: e.tamanho
      });
    });
  });

  /* ─── TAMANHO CHAMA O AMBIENTE ─────────────────────────────────────────
     Tamanho é a única escolha da coluna que não se resolve olhando o quadro
     sozinho: "50 × 70" não quer dizer nada contra um fundo neutro, e quer
     dizer tudo contra um sofá. Então escolher um tamanho traz o ambiente pro
     palco — a resposta aparece junto com a pergunta.
     Só na PRIMEIRA vez: se a pessoa já saiu do ambiente de propósito, trazê-lo
     de volta a cada clique seria desfazer a escolha dela.
     E sem rolar a página (ver a nota no `ambScrollMobile` do jun26.js): o palco
     troca atrás, e quem quiser olhar rola até lá. */
  var jaChamouAmbiente = false;
  function chamarAmbiente() {
    if (jaChamouAmbiente) return;
    var media = raiz.querySelector('.pp26-product-grid__media');
    if (!media || media.classList.contains('jun26-amb-on')) return;
    var tog = raiz.querySelector('.jun26-stage-toggle .rd-vertog');
    if (!tog) return;
    jaChamouAmbiente = true;
    tog.click();
  }

  /* cor e tamanho trocam sozinhos (label ↔ radio). Aqui só se REPINTA — e se
     reconcilia, caso a combinação escolhida não seja vendável. */
  vs.addEventListener('change', function (ev) {
    if (aplicando) return;
    if (!ev.target || ev.target.type !== 'radio') { pintar(); return; }
    if (ev.target.closest('[data-index="option3"]')) chamarAmbiente();
    var e = lerEstado();
    if (e.primario !== 'sem moldura' && e.cor && e.cor !== 'sem moldura') ultimaCor = e.cor;
    /* 25/set: a caixa que o 100x100 marcou VIAJA junto pra 70x70 — a pessoa
       viu o check e ele continua valendo; lá ela pode desmarcar */
    var r = resolver(e);
    if (r.mold !== marcado(fsMold) || r.cor !== marcado(fsCor) || r.tam !== marcado(fsTam)) {
      aplicar(e);
    } else {
      pintar();
    }
  });

  /* extras: o corpo abre e fecha na mesma curva do resto */
  if (togExtras && corpoExtras) {
    var abrirExtras = function (aberto) {
      togExtras.setAttribute('aria-expanded', String(aberto));
      corpoExtras.hidden = !aberto;
    };
    togExtras.addEventListener('click', function () {
      abrirExtras(togExtras.getAttribute('aria-expanded') !== 'true');
    });
    /* (6/ago) no desktop o card abre no HOVER e fecha quando o mouse sai —
       gesto de vitrine, sem clique. Só onde hover existe de verdade (mouse
       fino): no dedo continua o toque. O clique segue funcionando por cima
       (acessibilidade por teclado e quem prefere cravar o estado). */
    var mqHover = window.matchMedia('(min-width: 960px) and (hover: hover) and (pointer: fine)');
    linhaExtras.addEventListener('mouseenter', function () {
      if (mqHover.matches && !linhaExtras.hidden) abrirExtras(true);
    });
    linhaExtras.addEventListener('mouseleave', function () {
      if (mqHover.matches) abrirExtras(false);
    });
  }

  /* ⓘ no toque: no desktop o hover resolve, mas dedo não tem hover */

  /* ═══ (5/ago) NO CELULAR O "?" ABRE UMA FOLHA, NÃO UM BALÃO ══════════════
     Tooltip é gesto de mouse: nasce de um hover que o dedo não tem, e onde
     couber ele cobre alguma coisa. Empilhar no fluxo foi tentado e resolvia o
     "cobre", mas empurrava a página inteira pra baixo — a pessoa tocava num
     "?" e perdia o lugar onde estava.
     A folha é a gramática que a casa já fala: sobe de baixo, tem alça no topo,
     × do lado, escurece o resto e volta com um arrasto pra baixo. Componente
     PRÓPRIO da PDP 2026 — mesma gramática do que existe no tema, sem herdar
     o CSS de lá.
     Acima de 767px nada disso roda: no desktop o hover continua resolvendo. */
  var mqFolha = window.matchMedia('(max-width: 767px)');
  var folha = null, folhaScrim = null;

  function fechaFolha() {
    if (!folha) return;
    folha.classList.remove('is-on');
    folhaScrim.classList.remove('is-on');
    document.documentElement.style.overflow = '';
  }

  function montaFolha() {
    if (folha) return;
    folhaScrim = document.createElement('div');
    folhaScrim.className = 'pdp26-folha__scrim';
    folhaScrim.addEventListener('click', fechaFolha);

    folha = document.createElement('div');
    folha.className = 'pdp26-folha';
    folha.setAttribute('role', 'dialog');
    folha.setAttribute('aria-modal', 'true');
    folha.innerHTML =
      '<div class="pdp26-folha__grip" aria-hidden="true"></div>' +
      '<button type="button" class="pdp26-folha__x" aria-label="Fechar">' +
      '<svg viewBox="0 0 15.2 15.2" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.22" aria-hidden="true">' +
      '<path d="M0.6 0.6 L14.6 14.6 M14.6 0.6 L0.6 14.6"/></svg></button>' +
      '<p class="pdp26-folha__tit" data-no-relabel></p>' +
      '<div class="pdp26-folha__corpo"></div>';
    folha.querySelector('.pdp26-folha__x').addEventListener('click', fechaFolha);

    document.body.appendChild(folhaScrim);
    document.body.appendChild(folha);

    /* arrastar pra baixo fecha — o gesto que a alça promete */
    var y0 = null;
    folha.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    folha.addEventListener('touchend', function (e) {
      if (y0 == null) return;
      var t = e.changedTouches && e.changedTouches[0];
      if (t && t.clientY - y0 > 60) fechaFolha();
      y0 = null;
    }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechaFolha(); });
  }

  /* o título da folha é o rótulo da seção que o "?" acompanha — MOLDURA E COR,
     DIMENSÕES FINAIS. Sem isso a folha abre sem dizer do que está falando. */
  function rotuloDe(b) {
    var linha = b.closest('.pdp26-head, .pdp26-recibo__leg, .pdp26-bloco__cab') || b.parentElement;
    if (!linha) return '';
    /* o fallback lê a linha inteira — e a linha CONTÉM o balão, então o
       título vinha com a explicação colada nele. Lê-se uma cópia sem o "?"
       e sem a bolha: sobra o rótulo, que é o que se quer. */
    var copia = linha.cloneNode(true);
    copia.querySelectorAll('.pdp26-tip, .pdp26-i').forEach(function (n) { n.remove(); });
    return (copia.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function abreFolha(b) {
    var tip = b.querySelector('.pdp26-tip');
    if (!tip) return false;
    montaFolha();
    folha.querySelector('.pdp26-folha__tit').textContent = rotuloDe(b);
    folha.querySelector('.pdp26-folha__corpo').innerHTML = tip.innerHTML;
    folhaScrim.classList.add('is-on');
    folha.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  col.querySelectorAll('.pdp26-i').forEach(function (b) {
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (mqFolha.matches && abreFolha(b)) return;
      var jaEstava = b.classList.contains('is-on');
      col.querySelectorAll('.pdp26-i.is-on').forEach(function (o) { o.classList.remove('is-on'); });
      if (!jaEstava) b.classList.add('is-on');
    });
  });
  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('.pdp26-i')) return;
    col.querySelectorAll('.pdp26-i.is-on').forEach(function (o) { o.classList.remove('is-on'); });
  });

  /* ─── ponto de presença do consultor (3/ago) ────────────────────────────
     Verde pulsando só quando há gente: seg–sex 9h–18h no relógio de São
     Paulo (não no do visitante — quem atende está aqui). SÁBADO NÃO ABRE
     (3/ago, dono). Fora do horário o ponto fica cinza e o convite vira
     "Deixe uma mensagem" — promessa honesta em vez de convite vazio. */
  (function () {
    var pt = col.querySelector('[data-pdp26-presenca]');
    if (!pt) return;
    var agora = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
    var dia = agora.getDay(), hora = agora.getHours();
    var aberto = dia >= 1 && dia <= 5 && hora >= 9 && hora < 18;
    pt.classList.toggle('is-on', aberto);
    var txt = col.querySelector('[data-pdp26-consultor-txt]');
    /* (5/ago, 3ª volta) O EXPEDIENTE SAIU DA LINHA. Ele foi testado ali e
       reprovado: "Deixe uma mensagem" já é a promessa inteira — dizer o
       horário no mesmo fôlego transforma um convite curto numa placa de
       porta de loja. Quem quiser o expediente encontra no rodapé. */
    if (txt && !aberto) txt.textContent = 'Deixe uma mensagem';
  })();

  /* ─── nota em estrelas (3/ago) ──────────────────────────────────────────
     O Loox renderiza escondido (.pdp26-loox-fonte, servido pela section);
     daqui só se lêem os atributos e se pintam as estrelas DA CASA. O rating
     do app pode chegar depois do script dele — daí a espiada dupla. */
  (function () {
    var nota = col.querySelector('[data-pdp26-nota]');
    if (!nota) return;
    function tentar() {
      var lr = document.querySelector('.pdp26-loox-fonte .loox-rating, .loox-rating');
      if (!lr) return false;
      var r = parseFloat(lr.getAttribute('data-rating'));
      var n = parseInt(lr.getAttribute('data-raters'), 10);
      if (!r || !n) return false;
      var cheia = nota.querySelector('[data-pdp26-nota-cheia]');
      if (cheia) cheia.style.width = (r / 5 * 100) + '%';
      /* (4/ago) só o número: "4,8" — sem o "/5" */
      var txt = nota.querySelector('[data-pdp26-nota-txt]');
      if (txt) txt.textContent = String(Math.round(r * 10) / 10).replace('.', ',');
      /* (4/ago) a contagem vem da LOJA (127), não do contador do app deste
         produto — determinação do dono */
      var nEl = nota.querySelector('[data-pdp26-nota-n]');
      if (nEl) nEl.textContent = '127 avaliações';
      nota.setAttribute('aria-label', 'Nota ' + r + ' de 5, com ' + n + ' avaliações');
      nota.hidden = false;
      return true;
    }
    if (!tentar()) {
      var tent = 0;
      var iv = setInterval(function () {
        if (tentar() || ++tent > 20) clearInterval(iv);
      }, 500);
    }
  })();

  /* salvar e compartilhar — os dois alvos (manchete no desktop, fileira sob o
     palco no mobile) são o MESMO botão em papéis diferentes, então respondem
     juntos */
  var salvo = false;
  var confirmaTimer = null;
  /* 3/ago: cada botão guarda O PRÓPRIO rótulo de repouso — o da manchete diz
     "Salvar na lista" (rótulo que só aparece no hover), o da fileira diz
     "Salvar" (texto permanente, ao lado do glifo). Escrever o mesmo texto em
     todos fazia o de baixo herdar o do de cima. */
  col.querySelectorAll('[data-pdp26-save-label]').forEach(function (l) {
    l.setAttribute('data-pdp26-save-repouso', l.textContent.trim());
  });
  function pintarSave(estado) {
    /* raiz, não col: o SALVAR do sticky desktop mora fora do [data-pdp26-col]
       (o sticky é appendado na .pdp26-coluna, irmão do col) — varrer só o col
       deixava o botão de lá sem estado (6/ago) */
    raiz.querySelectorAll('[data-pdp26-save]').forEach(function (o) {
      o.setAttribute('aria-pressed', String(estado));
      var lbl = o.querySelector('[data-pdp26-save-label]');
      if (lbl) lbl.textContent = estado ? 'Salvo' : lbl.getAttribute('data-pdp26-save-repouso');
    });
  }
  /* (5/ago) A PÁGINA ABRE ENSINANDO: o rótulo "Salvar na lista" nasce à
     mostra e recolhe sozinho depois de 2,5s — quem nunca viu o glifo aprende
     o que ele faz, e quem já sabe não fica com um rótulo permanente na
     manchete. Mesma duração da confirmação "Salvo", pra ser o mesmo ritmo. */
  (function ensinarSave() {
    var alvos = col.querySelectorAll('.pdp26-icone--save');
    if (!alvos.length) return;
    alvos.forEach(function (o) { o.classList.add('is-ensinando'); });
    setTimeout(function () {
      alvos.forEach(function (o) { o.classList.remove('is-ensinando'); });
    }, 2500);
  })();

  /* (5/ago) O ESTADO VEM DO APP, NÃO DA MEMÓRIA DA PÁGINA.
     O `salvo` era uma variável local que nascia false: quem abrisse a PDP de
     uma obra JÁ salva via o bookmark vazio, e o primeiro clique "dessalvava"
     de fato enquanto a coluna pintava "Salvo" — os dois lados discordando.
     Aqui a fonte da verdade é o botão real do app (classe wk-selected), lido
     na carga e vigiado por observer: a coluna, o header e a barra fixa
     passam a contar sempre a mesma história. */
  /* (22/ago) …MAS O APP CHEGA DEPOIS. O Wishlist King hidrata o botão
     escondido DEPOIS deste script rodar: o querySelector acima voltava null
     e o `return` matava o espelho inteiro — sem primeira leitura e sem os
     observers. Resultado: quem voltava a uma obra já salva via o bookmark
     vazio, e o toque seguinte removia do app enquanto a UI pintava "Salvo"
     (exatamente o bug que o 5/ago descreveu, renascido por timing).
     Agora o vigia de documento nasce SEMPRE e adota o botão quando (e cada
     vez que) ele aparecer — o observer de classe muda junto. */
  (function espelharAppNoSalvo() {
    var wkBtn = null;
    var ler = function () {
      if (!wkBtn) return;
      var estaSalvo = wkBtn.classList.contains('wk-selected');
      if (estaSalvo === salvo) return;
      salvo = estaSalvo;
      pintarSave(salvo);
    };
    var vigiaClasse = new MutationObserver(ler);
    function achar() {
      return document.querySelector('.pdp26-wishlist-fonte .wk-button, .thb-product-detail wishlist-button-product .wk-button');
    }
    function adotar(novo) {
      if (!novo || novo === wkBtn) return;
      wkBtn = novo;
      vigiaClasse.disconnect();
      vigiaClasse.observe(wkBtn, { attributes: true, attributeFilter: ['class'] });
      ler();
    }
    adotar(achar());
    /* o app re-renderiza o botão inteiro em algumas ações — reencontra */
    new MutationObserver(function () {
      adotar(achar());
    }).observe(document.documentElement, { subtree: true, childList: true });
  })();

  col.querySelectorAll('[data-pdp26-save]').forEach(function (b) {
    b.addEventListener('click', function () {
      salvo = !salvo;
      pintarSave(salvo);
      /* a confirmação FLUTUANTE (só a da manchete, que cobre a nota) é
         transiente: pisca "Salvo" e recolhe em 2,5s. O botão de texto da
         fileira mantém "Salvo" — ali o rótulo é o próprio estado. */
      col.querySelectorAll('.pdp26-icone--save').forEach(function (o) {
        o.classList.toggle('is-confirmando', salvo);
      });
      clearTimeout(confirmaTimer);
      if (salvo) {
        confirmaTimer = setTimeout(function () {
          col.querySelectorAll('.pdp26-icone--save').forEach(function (o) {
            o.classList.remove('is-confirmando');
          });
          /* 4/ago: o texto só troca DEPOIS que o rótulo terminou de recolher.
             Trocar junto com a classe fazia o novo texto aparecer dentro da
             própria animação de saída — lia-se "Salvo", ele começava a
             encolher e no meio do caminho virava outra frase, que então
             sumia. Parecia travamento, e era só ordem errada. 0,32s é a
             duração da transição de max-width no CSS; 360ms dá a folga do
             último quadro. */
          setTimeout(function () {
            col.querySelectorAll('.pdp26-icone--save').forEach(function (o) {
              var lbl = o.querySelector('[data-pdp26-save-label]');
              /* 3/ago: com a peça JÁ salva, o rótulo de hover diz a ação que
                 resta — "Remover da lista" — e não repete o convite de salvar */
              if (lbl) lbl.textContent = salvo ? 'Remover da lista' : lbl.getAttribute('data-pdp26-save-repouso');
            });
          }, 360);
        }, 2500);
      }
      /* a lista de salvos é do app de wishlist; aqui só se reencaminha o
         clique pro botão dele, que já existe na página */
      var wk = document.querySelector('.thb-product-detail wishlist-button-product button, .thb-product-detail wk-button button');
      if (wk) wk.click();
    });
  });
  col.querySelectorAll('[data-pdp26-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dados = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(dados).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).catch(function () {});
    });
  });

  /* ─── barra fixa (mobile) ───────────────────────────────────────────────
     Ela só entra depois que o bloco real de compra SAI PELA CIMA. Enquanto os
     botões de verdade estão à frente — ou ainda abaixo, não alcançados — não
     há barra: senão vira duplicação e come 170px permanentes de uma tela de
     844 (spec §5e). */
  var barra = col.querySelector('[data-pdp26-barra]');
  var compra = col.querySelector('.pdp26-compra');
  if (barra && compra && 'IntersectionObserver' in window) {
    var mq = window.matchMedia('(max-width: 959px)');
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        var passou = !en.isIntersecting && en.boundingClientRect.top < 0;
        barra.classList.toggle('is-on', passou && mq.matches);
      });
    }, { threshold: 0 }).observe(compra);

    barra.querySelector('[data-pdp26-barra-add]').addEventListener('click', function () {
      var cta = col.querySelector('.pdp26-cta--primaria');
      if (cta) cta.click();
    });
  }

  pintar();

  /* ─── (6/ago) CTA CONCLUÍDO: o check assume o rótulo ──────────────────
     O tema tira o .loading no finally; o cart:item-added chega um tique
     antes. Aqui o botão fica 2s dizendo "Adicionado ao carrinho" com o
     check (CSS .pdp26-added) e devolve o rótulo original sozinho. Sem
     toast: o próprio botão narra os três estados. */
  (function () {
    var ctaAdd = col.querySelector('.pdp26-cta--primaria');
    var rotulo = ctaAdd && ctaAdd.querySelector('.single-add-to-cart-button--text');
    if (!rotulo) return;
    var original = rotulo.textContent;
    var volta = null;
    document.addEventListener('cart:item-added', function () {
      ctaAdd.classList.add('pdp26-added');
      rotulo.textContent = 'Adicionado ao carrinho';
      clearTimeout(volta);
      volta = setTimeout(function () {
        ctaAdd.classList.remove('pdp26-added');
        rotulo.textContent = original;
      }, 2000);
    });
  })();

  /* ─── (6/ago) o "+7" da ficha abre as formas de pagamento ──────────────
     A ficha mostra três bandeiras; o resto mora no drawer, como no trust
     block do jun26. Se aquele já criou o #RD-Pay-Drawer, reusa — senão monta
     um igual, com as mesmas classes (o CSS do side-panel já existe). */
  (function () {
    var gatilhos = col.querySelectorAll('.pdp26-ficha__mais');
    if (!gatilhos.length) return;
    function base() {
      var l = document.querySelector('link[href*="pdp2026"]') ||
              document.querySelector('link[href*="redesign-pdp"]');
      return l ? l.href.replace(/[^\/]+\.css.*$/, '') : '';
    }
    function bandeiras(lista) {
      return '<div class="rd-pay__flags">' + lista.map(function (m) {
        return '<img class="rd-trust__flag" src="' + base() + 'obrah-pagamento-' + m + '.svg" alt="" loading="lazy">';
      }).join('') + '</div>';
    }
    function monta() {
      var d = document.getElementById('RD-Pay-Drawer');
      if (d) return d;
      d = document.createElement('div');
      d.id = 'RD-Pay-Drawer';
      d.className = 'side-panel rd-pay-drawer';
      /* mesmas SEÇÕES do drawer do jun26 (cartão · PIX · boleto · faturado):
         a lista solta de bandeiras não dizia condição nenhuma. */
      d.innerHTML = ''
        + '<div class="side-panel-inner">'
        +   '<div class="side-panel-header"><div>'
        +     '<h4 class="body-font">Formas de pagamento</h4>'
        +     '<side-panel-close class="side-panel-close" data-pdp26-pay-x>'
        +       '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        +     '</side-panel-close>'
        +   '</div></div>'
        +   '<div class="side-panel-content"><div class="rd-pay">'
        +     '<div class="rd-pay__sec"><div class="rd-pay__t">Cartão de crédito</div>'
        +       bandeiras(['visa', 'master', 'elo', 'amex', 'hipercard', 'diners', 'discover', 'jcb'])
        +       '<p class="rd-pay__s">Em até 3x sem juros — ou em até 12x. Aceitamos Visa, Mastercard, Elo, American Express, Hipercard, Diners, Discover e JCB.</p></div>'
        +     '<div class="rd-pay__sec"><div class="rd-pay__t">PIX</div>' + bandeiras(['pix'])
        +       '<p class="rd-pay__s">10% de desconto e aprovação na hora.</p></div>'
        +     '<div class="rd-pay__sec"><div class="rd-pay__t">Boleto</div>' + bandeiras(['boleto'])
        +       '<p class="rd-pay__s">À vista, com compensação em até 3 dias úteis.</p></div>'
        +     '<div class="rd-pay__sec"><div class="rd-pay__t">Faturado para empresas</div>'
        +       '<p class="rd-pay__s">Compras com CNPJ podem ser faturadas — fale com a nossa equipe pelo WhatsApp.</p></div>'
        +   '</div></div>'
        + '</div>';
      document.body.appendChild(d);
      d.addEventListener('click', function (e) {
        if (e.target.closest('[data-pdp26-pay-x]') || !e.target.closest('.side-panel-inner')) {
          d.classList.remove('active');
          document.body.classList.remove('open-cc');
        }
      });
      return d;
    }
    gatilhos.forEach(function (g) {
      g.addEventListener('click', function (e) {
        /* o tema tem um "clique fora fecha o painel" no document: sem parar a
           propagação, o MESMO clique que abre era lido como clique fora e o
           drawer fechava no mesmo quadro. O rAF garante que a classe entre
           depois do ciclo de eventos, não durante. */
        e.preventDefault();
        e.stopPropagation();
        var d = monta();
        requestAnimationFrame(function () {
          document.body.classList.add('open-cc');
          d.classList.add('active');
        });
      });
    });
  })();

  /* ─── a sincronia de abertura ───────────────────────────────────────────
     O palco é montado pelo Liquid da galeria, que lê
     `selected_or_first_available_variant`; a coluna abre na variante da casa
     (canvas + madeira clara). Quando as duas discordam — que é o caso comum —
     o quadro na foto não é o quadro descrito ao lado.
     Um `change` só resolve, porque é ele que faz o `variant-selects` emitir o
     `product:variant-change` que o motor de moldura escuta. Disparado apenas
     no desacordo: com `?variant=` na URL os dois já nascem iguais e nada é
     pedido à rede. */
  (function sincronizarPalco() {
    var frame = raiz.querySelector('.pp26__frame');
    if (!frame) return;
    var TIPO = {
      'canvas': 'canvas', 'padrão': 'padrao', 'sem moldura': 'sem-moldura',
      'padrão com paspatur': 'padrao-com-paspatur', 'caixa': 'caixa',
      'caixa com paspatur': 'caixa-com-paspatur', 'slim': 'slim',
      'slim com paspatur': 'slim-com-paspatur'
    };
    var COR = { 'madeira escura': 'mel', 'preta': 'preta', 'madeira clara': 'pinus', 'branca': 'branca', 'sem moldura': 'default' };
    var tipoOk = TIPO[marcado(fsMold)];
    var corOk = COR[marcado(fsCor)];
    if (frame.dataset.frameType === tipoOk && frame.dataset.frameColor === corOk) return;
    vs.dispatchEvent(new Event('change', { bubbles: true }));
  })();

  /* ═══ SALVAR E COMPARTILHAR NA LINHA DO ARTISTA (4/ago, mobile) ══════════
   Eles moravam numa faixa própria entre o palco e a manchete: uma linha
   inteira da tela, com rótulo e fio embaixo, gasta em duas ações
   secundárias — e ocupando justamente o lugar onde a leitura deveria
   começar. Quem abre a página quer saber que obra é aquela, não o que dá
   pra fazer com ela.

   Aqui eles viram dois ícones no fim da linha do artista, que já existe e
   estava com o lado direito vazio. É o mesmo arranjo que o desktop usa há
   tempos (lá o salvar mora ao lado da nota), então as duas telas voltam a
   contar a mesma história. A nota desce pra baixo do título: sem os ícones
   disputando a linha ela ficaria espremida no meio, e embaixo do nome é
   onde ela é lida como avaliação DA obra.

   Os botões são movidos, não recriados — o app de favoritos e o share
   nativo seguem pendurados neles. */
(function acoesNaLinhaDoArtista() {
  /* (4/ago, publicação) o arranjo virou UNIVERSAL: desktop também esconde a
     faixa e leva o compartilhar pra linha do artista, com a nota descendo
     pra baixo do título — as duas visões contam a mesma história. */
  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;
  var manchete = raiz.querySelector('.pdp26-manchete');
  var topo = raiz.querySelector('.pdp26-manchete__topo');
  var acoes = raiz.querySelector('.pdp26-acoes');
  if (!manchete || !topo || !acoes) return;

  /* o SALVAR usado aqui é o MESMO do desktop (.pdp26-icone--save), que já
     estava montado na manchete e só ficava escondido no mobile. Isso não é
     detalhe de código: é ele que tem a confirmação "Salvo" — o rótulo que
     corre pra esquerda e recolhe em 2,5s. O botão da fileira só troca um
     texto, e como aqui o texto some, salvar virava um clique sem resposta
     (4/ago: "não tá aparecendo o salvo que nem desktop"). Da fileira vem só
     o compartilhar, que não tem equivalente na manchete. */
  var share = [].slice.call(acoes.querySelectorAll('.pdp26-acoes__b'))
    .filter(function (b) { return !b.hasAttribute('data-pdp26-save'); })[0];
  var nota = raiz.querySelector('.pdp26-nota');
  if (!share || !nota) return;

  /* MOVER É EMPRESTAR, E QUEM EMPRESTA DEVOLVE. A primeira versão arrumava
     tudo uma vez, no carregamento — e quem abrisse no desktop e estreitasse
     a janela (ou o contrário) ficava com metade de cada arranjo: a fileira
     de volta com fio e rótulo, a nota em duas casas ao mesmo tempo. Guardar
     o vizinho de origem de cada peça é o que permite refazer o caminho. */
  var casaShare = { pai: share.parentNode, depoisDe: share.nextSibling };
  var casaNota = { pai: nota.parentNode, depoisDe: nota.nextSibling };

  if (share.parentNode !== topo) topo.appendChild(share);
  if (nota.parentNode !== manchete) manchete.appendChild(nota);
  raiz.classList.add('pdp26-acoes-na-manchete');
})();

/* ═══ FECHAR — comportamento de DRAWER com histórico real (4/ago) ═══════
     A PDP no mobile lê como uma gaveta sobre a listagem, mas continua sendo
     uma PÁGINA de verdade: URL própria, histórico, SEO e compartilhamento
     intactos. O X volta pra de onde a pessoa veio (com a posição de scroll
     preservada pelo próprio navegador) e só cai na coleção quando não há
     histórico interno — link de fora, aba nova, campanha. */
  (function fecharDrawer() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var palco = raiz.querySelector('.pp26-product-grid__media');
    if (!palco || palco.querySelector('[data-pdp26-fechar]')) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pdp26-fechar';
    b.setAttribute('data-pdp26-fechar', '');
    b.setAttribute('aria-label', 'Voltar');
    /* (4/ago) SETA no lugar do X: o X promete fechar uma camada, e o que
       acontece aqui é voltar pra listagem de onde a pessoa veio — com o
       scroll no lugar. A seta conta essa história certa. */
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5"/><path d="M11 18l-6-6 6-6"/></svg>';

    /* o palco escuta clique/toque pra dar ZOOM — sem barrar a propagação
       aqui, tocar no X abria o zoom junto (4/ago, ao vivo). Barra nas três
       fases porque o handler do jun26 escuta em captura. */
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
      b.addEventListener(ev, function (e) { e.stopPropagation(); }, false);
    });

    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var deDentro = false;
      try {
        deDentro = !!document.referrer && new URL(document.referrer).origin === location.origin;
      } catch (e) {}
      /* history.length > 1 sozinho mente: uma aba nova aberta por link
         externo também soma entrada. O referrer é quem diz se há pra onde
         voltar dentro da casa. */
      if (deDentro && history.length > 1) history.back();
      else window.location.href = (window.__pdp26Voltar || '/collections/all');
    });

    /* ── barra do topo: X à esquerda, ferramentas do site à direita ───────
       Com o header fora de cena, buscar/favoritos/carrinho ficariam
       inalcançáveis — a pessoa teria que fechar a PDP só pra usar o site.
       Em vez de recriar os ícones (e ter que sincronizar contadores, cart
       drawer e o app de favoritos), a fileira REAL do header é movida pra
       cá: os listeners sobrevivem ao appendChild, então tudo continua
       funcionando exatamente como funcionava lá em cima. */
    var barra = document.createElement('div');
    barra.className = 'pdp26-topo';
    barra.appendChild(b);

    var ferramentas = document.querySelector('.header.obrah-style .thb-secondary-area');
    if (ferramentas) {
      /* (4/ago) EMPRÉSTIMO COM DEVOLUÇÃO. A fileira é movida, não copiada —
         e quem move tem que saber devolver. Sem isto, abrir a PDP no celular
         e alargar a janela deixava lupa/favoritos/sacola soltos no meio da
         obra: o palco vira desktop, a barra do topo some, mas os ícones
         continuam pendurados nela (visto ao vivo em ~1434px). Guardar o
         vizinho de origem permite recolocá-los na posição exata. */
      ferramentas.__pdp26Casa = { pai: ferramentas.parentNode, depoisDe: ferramentas.nextSibling };
      ferramentas.setAttribute('data-pdp26-emprestada', '');
      /* o tick do header ajusta margens INLINE por medição incremental. Ao
         sair do header essas medidas perdem o sentido (e chegaram a somar
         −19883px antes da guarda existir). Zera tudo que ele possa ter
         escrito, aqui e nos filhos, pra fileira nascer limpa nesta barra. */
      ['margin-left', 'margin-right', 'left', 'top', 'right', 'bottom', 'transform']
        .forEach(function (prop) { ferramentas.style.removeProperty(prop); });
      [].slice.call(ferramentas.querySelectorAll('*')).forEach(function (el) {
        ['margin-left', 'margin-right', 'left', 'top', 'right', 'bottom', 'transform']
          .forEach(function (prop) { el.style.removeProperty(prop); });
      });
      barra.appendChild(ferramentas);
    }

    /* o palco inteiro escuta toque pra dar zoom — a barra vive dentro dele,
       então um clique aqui abria o zoom junto. A barreira fica na fase de
       BOLHA, não na de captura: em captura ela interceptava o evento ANTES
       dos próprios botões, e lupa/favoritos/sacola paravam de funcionar
       (4/ago, ao vivo: "não tá clicando direito"). Na bolha, o botão faz o
       que tem que fazer e só então o evento morre, sem chegar ao palco. */
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (ev) {
      barra.addEventListener(ev, function (e) { e.stopPropagation(); }, false);
    });

    palco.appendChild(barra);

    /* a janela pode crescer depois de tudo montado — no tablet girando, no
       desktop arrastando a borda. Quando ela sai do mobile, a barra do topo
       deixa de existir visualmente, mas os ícones seguem sendo filhos dela:
       devolvê-los ao header é o que impede que fiquem soltos sobre a obra.
       Na volta ao mobile eles são reemprestados, e o ciclo se fecha. */
    (function devolveNoDesktop() {
      var mq = window.matchMedia('(max-width: 767px)');
      function ajusta() {
        var casa = ferramentas && ferramentas.__pdp26Casa;
        if (!casa || !casa.pai) return;
        if (mq.matches) {
          if (ferramentas.parentNode !== barra) {
            ferramentas.setAttribute('data-pdp26-emprestada', '');
            barra.appendChild(ferramentas);
          }
        } else if (ferramentas.parentNode === barra) {
          ferramentas.removeAttribute('data-pdp26-emprestada');
          casa.pai.insertBefore(ferramentas, casa.depoisDe || null);
        }
        barra.style.display = mq.matches ? '' : 'none';
      }
      /* addListener é o nome antigo; Safari só ganhou addEventListener aqui
         no 14, e a loja ainda recebe visita de iOS mais velho */
      if (mq.addEventListener) mq.addEventListener('change', ajusta);
      else if (mq.addListener) mq.addListener(ajusta);
      window.addEventListener('resize', ajusta);
      ajusta();
    })();

    /* o app do favorito posiciona a bolinha com um transform inline medido
       PARA O HEADER. Aqui ela vive noutro lugar, então o transform manda
       ela pra longe do glifo. O header tinha um tick que zerava isso, mas
       ele não roda mais nesta fileira (ela está emprestada) — então a
       limpeza passa a ser daqui, e reaplicada a cada re-render do app. */
    (function seguraBolinha() {
      function limpa() {
        [].slice.call(barra.querySelectorAll('wk-counter, .wk-counter')).forEach(function (c) {
          c.style.setProperty('transform', 'none', 'important');
          ['left', 'top', 'right', 'bottom'].forEach(function (k) { c.style.removeProperty(k); });
        });
        /* (22/ago) o carimbo do ZERO também é daqui: o tick do header só
           varre `.header.obrah-style ...`, e esta fileira mora fora dele.
           Sem o carimbo, o ponto da lista (que substitui a bolinha, ver
           CSS) ficava aceso com a lista vazia. Mesma leitura do header:
           vazio, "0" ou "(0)" = zero. */
        [].slice.call(barra.querySelectorAll('wishlist-link .wk-counter')).forEach(function (c) {
          /* (22/ago) o tick do header silencia o número com inline
             !important (font-size 0) pro visual de lá — aqui o selo MOSTRA
             o número, e só remover a propriedade inline devolve a palavra
             ao CSS do selo */
          ['font-size', 'color', 'background', 'padding', 'margin'].forEach(function (p) {
            if (c.style.getPropertyValue(p) !== '') c.style.removeProperty(p);
          });
          var t = (c.textContent || '').trim();
          var zero = (t === '' || t === '0' || t === '(0)');
          /* só escreve quando o estado MUDA: o observer desta limpeza escuta
             atributos, e um setAttribute incondicional o acordaria em loop */
          [c, c.closest('wk-counter')].forEach(function (alvo) {
            if (!alvo) return;
            if (zero && !alvo.hasAttribute('data-obrah-zero')) alvo.setAttribute('data-obrah-zero', '');
            else if (!zero && alvo.hasAttribute('data-obrah-zero')) alvo.removeAttribute('data-obrah-zero');
          });
          /* (22/ago) O GLIFO PASSA A CONTAR também aqui: o tick do header
             não varre a fileira emprestada, então o carimbo do bookmark
             cheio é responsabilidade desta limpeza. Mesma guarda de escrita. */
          var wl = c.closest('wishlist-link');
          if (wl) {
            if (!zero && !wl.hasAttribute('data-obrah-lista-cheia')) wl.setAttribute('data-obrah-lista-cheia', '');
            else if (zero && wl.hasAttribute('data-obrah-lista-cheia')) wl.removeAttribute('data-obrah-lista-cheia');
          }
        });
        /* (22/ago) o ZERO da SACOLA também é daqui: o syncCartCount do
           header varre `.header.obrah-style ...` e esta fileira mora fora —
           por isso o "0" ficava no ar. Mesma leitura e mesma guarda. */
        [].slice.call(barra.querySelectorAll('.thb-secondary-cart .thb-item-count')).forEach(function (b) {
          var t = (b.textContent || '').trim();
          var zero = (t === '' || t === '0' || t === '(0)');
          if (zero && !b.hasAttribute('data-obrah-zero')) b.setAttribute('data-obrah-zero', '');
          else if (!zero && b.hasAttribute('data-obrah-zero')) b.removeAttribute('data-obrah-zero');
        });
      }
      limpa();
      try { new MutationObserver(limpa).observe(barra, { subtree: true, attributes: true, childList: true }); } catch (e) {}
      var n = 0, iv = setInterval(function () { limpa(); if (++n > 30) clearInterval(iv); }, 200);
    })();
  })();

  /* ═══ FATIA 3 (3/ago, P26·44/45) — fita, vista frontal e trilho vivo ═════
     Modelo de interação: FITA = operar (chips saltam direto; setas andam a
     SEQUÊNCIA inteira: frontal → perspectiva → ambientes → volta) ·
     TRILHO = passear (deriva sozinho ~20px/s, freia no hover em ~0,4s,
     retoma ao sair; fila circular; clique no tile troca o palco travado).
     O palco continua sendo do jun26.js — daqui só se fala com a ponte
     window.__pdp26Amb (ver o contrato lá). Os tiles do trilho entram em
     window.__pdp26Tiles e o pintaMini do motor os pinta na mesma passada
     das miniaturas — vistas COMPOSTAS, nunca foto crua de ambiente. */
  (function fatia3() {
    var fita = raiz.querySelector('[data-pdp26-fita]');
    var trilho = raiz.querySelector('[data-pdp26-trilho]');
    var mediaCol = raiz.querySelector('.pp26-product-grid__media');
    if ((!fita && !trilho) || !mediaCol) return;
    /* desktop-only por enquanto: no mobile a fita do palco atual segue no ar */
    if (!window.matchMedia('(min-width: 768px)').matches) return;

    var reduzMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function comPalco(cb) {
      if (window.__pdp26Amb) return cb(window.__pdp26Amb);
      raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
    }

    comPalco(function (palco) {
      if (!palco) return;
      var envs = palco.envs || [];
      function rotulo(e) {
        var s = String(e.label || e.id || '');
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
      }

      /* ── vista frontal — o quadro montado sobre o fundo do palco ─────────
         Placeholder desenhado (moldura em CSS na escala física, como o
         ambientado e as minis) até o PNG frontal novo chegar do dono. */
      var VISTA_CLS = 'pdp26-vista-frontal';
      var vista = 'perspectiva';
      var frontal = null, frontalQuadro = null, frontalPasp = null, frontalArte = null;
      function montaFrontal() {
        if (frontal) return;
        frontal = document.createElement('div');
        frontal.className = 'pdp26-frontal';
        frontal.setAttribute('aria-hidden', 'true');
        frontalQuadro = document.createElement('div');
        frontalQuadro.className = 'pdp26-frontal__quadro';
        frontalPasp = document.createElement('div');
        frontalPasp.className = 'pdp26-frontal__pasp';
        frontalArte = document.createElement('img');
        frontalArte.className = 'pdp26-frontal__arte';
        frontalArte.alt = '';
        frontalArte.draggable = false;
        frontalPasp.appendChild(frontalArte);
        frontalQuadro.appendChild(frontalPasp);
        frontal.appendChild(frontalQuadro);
        mediaCol.appendChild(frontal);
      }
      function pintaFrontal() {
        if (!frontal) return;
        var e = lerEstado();
        var d = medida(e.tamanho);
        if (!d) return;
        var face = e.primario === 'canvas' ? 1.5 : e.primario === 'padrão' ? (e.fino ? FACE_SLIM : 2) : 0;
        var pasp = (e.primario === 'padrão' && e.paspatur) ? PASPATUR_CM : 0;
        var wcm = d.w + 2 * (face + pasp), hcm = d.h + 2 * (face + pasp);
        var cw = mediaCol.clientWidth, ch = mediaCol.clientHeight;
        if (!cw || !ch) return;
        /* a câmera do frontal é a MESMA da perspectiva: a arte frontal nasce
           do tamanho que a arte tem no slide de perspectiva — trocar de vista
           não pode mudar o tamanho aparente do quadro (só o ângulo). */
        var artP = raiz.querySelector('.pp26__slide--perspective .pp26__art');
        var hRef = 0;
        if (artP) hRef = artP.getBoundingClientRect().height;
        if (!hRef) hRef = ch * 0.66;
        var esc = hRef / d.h;
        /* e o quadro pronto (arte + moldura + paspatur) ainda cabe no palco */
        esc = Math.min(esc, ch * 0.82 / hcm, cw * 0.72 / wcm);
        frontalQuadro.style.width = (wcm * esc).toFixed(1) + 'px';
        frontalQuadro.style.height = (hcm * esc).toFixed(1) + 'px';
        frontalQuadro.style.borderWidth = (face * esc).toFixed(2) + 'px';
        frontalQuadro.style.borderColor = PERFIL[e.cor] || PERFIL['madeira clara'];
        frontalQuadro.classList.toggle('pdp26-frontal__quadro--solta', e.primario === 'sem moldura');
        frontalPasp.style.padding = (pasp * esc).toFixed(2) + 'px';
        var art = raiz.querySelector('.pp26__slide--perspective .pp26__art');
        if (art && art.currentSrc && frontalArte.src !== art.currentSrc) frontalArte.src = art.currentSrc;
        else if (art && art.src && !frontalArte.src) frontalArte.src = art.src;
      }
      function aplicaVista(v) {
        vista = v;
        if (v === 'frontal') { montaFrontal(); pintaFrontal(); }
        mediaCol.classList.toggle(VISTA_CLS, v === 'frontal');
      }

      /* ── o estado corrente, sempre derivado do motor ───────────────────── */
      function idEnvAtivo() {
        var on = raiz.querySelector('.jun26-env-dd__menu .jun26-env-dd__opt.is-on');
        return (on && on.dataset.mode !== 'quadro') ? on.dataset.mode : null;
      }
      function chaveAtual() {
        if (mediaCol.classList.contains('jun26-amb-on')) return idEnvAtivo() || vista;
        return vista;
      }
      /* 3/ago (ao vivo): FRONTAL DESLIGADO por enquanto — sai da sequência,
         da fita e do trilho; volta quando o PNG do dono chegar (flag +
         devolver o chip no Liquid; o desenho CSS fica dormente) */
      var COM_FRONTAL = false;
      var SEQ = (COM_FRONTAL ? ['frontal'] : []).concat(['perspectiva']).concat(envs.map(function (e) { return e.id; }));
      function irPara(chave) {
        if (chave === 'frontal' || chave === 'perspectiva') {
          aplicaVista(chave);
          if (palco.modo() !== 'quadro') palco.setMode('quadro');
        } else {
          palco.setMode(chave);
        }
        sincroniza();
      }

      /* ── fita ──────────────────────────────────────────────────────────── */
      var chips = {};
      var chipAmb = null;
      /* o modo ambiente é UM chip ("Ambientado", 3/ago ao vivo) — ele leva pro
         último cômodo visitado; passear entre cômodos é papel das setas e do
         trilho */
      var ultimoEnv = envs.length ? envs[0].id : null;
      if (fita) {
        var chipsWrap = fita.querySelector('[data-pdp26-fita-chips]');
        [].slice.call(chipsWrap.querySelectorAll('[data-pdp26-vista]')).forEach(function (b) {
          chips[b.dataset.pdp26Vista] = b;
          b.addEventListener('click', function () { irPara(b.dataset.pdp26Vista); });
        });
        chipAmb = chipsWrap.querySelector('[data-pdp26-amb]');
        if (chipAmb) {
          if (envs.length) chipAmb.addEventListener('click', function () { if (ultimoEnv) irPara(ultimoEnv); });
          else chipAmb.hidden = true;
        }
        [].slice.call(fita.querySelectorAll('[data-pdp26-fita-seta]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var passo = parseInt(b.dataset.pdp26FitaSeta, 10) || 1;
            /* CICLO ABERTO (3/ago, decisão final DO DONO depois de usar): as
               setas percorrem a sequência INTEIRA em círculo — do primeiro
               cômodo, voltar cai na perspectiva; do último, avançar idem.
               (O loop fechado nos cômodos foi testado e ele sentiu falta da
               saída pela seta; os chips seguem como atalho direto.) */
            var i = SEQ.indexOf(chaveAtual());
            irPara(SEQ[(i + passo + SEQ.length) % SEQ.length]);
          });
        });
      }

      /* ── trilho vivo ───────────────────────────────────────────────────── */
      var track = trilho && trilho.querySelector('[data-pdp26-trilho-track]');
      var janela = trilho && trilho.querySelector('[data-pdp26-trilho-janela]');
      var tiles = [];
      var loopW = 0;
      function montaTile(chave) {
        var e = null;
        for (var i = 0; i < envs.length; i++) if (envs[i].id === chave) e = envs[i];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp26-trilho__tile pdp26-trilho__tile--' + (e ? 'amb' : chave);
        b.dataset.mode = e ? e.id : 'quadro';   /* contrato do pintaMini */
        b.dataset.pdp26Chave = chave;
        b.setAttribute('aria-label', chave === 'frontal' ? 'Vista frontal' : chave === 'perspectiva' ? 'Vista em perspectiva' : rotulo(e));
        if (e) b.style.setProperty('--rd-envthumb', 'url("' + palco.srcDe(e) + '")');
        var cena = document.createElement('span');
        cena.className = 'rd-envth__cena';
        var art = document.createElement('i');
        art.className = 'rd-envth__art';
        cena.appendChild(art);
        b.appendChild(cena);
        /* sem legenda nos tiles (3/ago, ao vivo) — a cena fala sozinha, mesma
           regra das miniaturas do palco; o nome fica no aria-label */
        b.addEventListener('click', function () {
          irPara(chave);
          /* o clique VOLTA pro viewport (pedido ao vivo): a troca acontece no
             palco travado lá em cima — sem subir, ela fica invisível */
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        return b;
      }
      if (track && janela) {
        /* a fila do trilho NÃO repete a perspectiva — é a imagem que o palco
           já mostra no viewport (3/ago, ao vivo). O trilho complementa:
           frontal + ambientes. */
        var TRILHO_SEQ = SEQ.filter(function (k) { return k !== 'perspectiva'; });
        /* uma volta completa da fila; repetida até a janela nunca ver o fim */
        var poeVolta = function () {
          TRILHO_SEQ.forEach(function (chave) {
            var t = montaTile(chave);
            track.appendChild(t);
            tiles.push(t);
          });
        };
        poeVolta();
        /* +10 = o gap do CSS entre a última e a primeira da próxima volta */
        loopW = track.scrollWidth + 10;
        var alvoW = Math.max(janela.clientWidth || window.innerWidth, 800) * 2;
        var voltas = 1;
        /* (4/ago) MÍNIMO DE 2 VOLTAS, sempre: com uma volta só, a última
           borda era o fim do mundo — a seta não achava alvo adiante e o
           trilho TRAVAVA no fim ("aí no final tem que voltar"). Duas voltas
           dão à fila um "depois" pra onde ir, e o wrap fecha o círculo. */
        while (voltas < 2 || (loopW * voltas < alvoW && voltas < 6)) { poeVolta(); voltas++; }

        window.__pdp26Tiles = tiles;
        palco.pinta();

        /* deriva de vitrine: ~20 px/s, freio exponencial no hover (~0,4s pra
           parar), retomada na mesma curva. `prefers-reduced-motion` = parado —
           as setas continuam trabalhando. */
        var offset = 0, v = 0, tPrev = null, rafId = null;
        var pausa = false, visivel = false, animSeta = null;
        function aplica() {
          track.style.transform = 'translate3d(' + (-offset).toFixed(2) + 'px,0,0)';
        }
        function anima(t) {
          rafId = null;
          if (tPrev == null) tPrev = t;
          var dt = Math.min(0.05, (t - tPrev) / 1000);
          tPrev = t;
          if (animSeta) {
            if (animSeta.t0 == null) animSeta.t0 = t;
            var p = Math.min(1, (t - animSeta.t0) / animSeta.dur);
            var ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
            offset = animSeta.de + (animSeta.para - animSeta.de) * ease;
            if (p >= 1) animSeta = null;
          } else {
            var alvo = (pausa || !visivel || reduzMotion.matches) ? 0 : 20;
            v += (alvo - v) * Math.min(1, dt / 0.16);
            if (alvo === 0 && Math.abs(v) < 0.05) { v = 0; tPrev = null; aplica(); return; }
            offset += v * dt;
          }
          /* o laço circular NÃO mexe no offset no meio de um passo de seta —
             senão o pulo de volta quebra a interpolação (3/ago) */
          if (!animSeta) {
            while (offset >= loopW) offset -= loopW;
            while (offset < 0) offset += loopW;
          }
          aplica();
          rafId = requestAnimationFrame(anima);
        }
        function acorda() {
          if (!rafId) { tPrev = null; rafId = requestAnimationFrame(anima); }
        }
        /* o freio vale pro trilho INTEIRO, setas incluídas — com a pausa só na
           janela, a esteira retomava por cima do passo pra trás (3/ago) */
        trilho.addEventListener('mouseenter', function () { pausa = true; acorda(); });
        trilho.addEventListener('mouseleave', function () { pausa = false; acorda(); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            visivel = !!(en[0] && en[0].isIntersecting);
            if (visivel) acorda();
          }).observe(trilho);
        } else { visivel = true; acorda(); }
        if (reduzMotion.addEventListener) reduzMotion.addEventListener('change', acorda);

        /* setas das pontas: quem quer mandar no ritmo anda tile a tile */
        [].slice.call(trilho.querySelectorAll('[data-pdp26-trilho-seta]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var dir = parseInt(b.dataset.pdp26TrilhoSeta, 10) || 1;
            /* voltar do começo da fila: salta uma volta inteira pra frente —
               visual idêntico (o track tem 2+ voltas) — e a borda anterior
               passa a existir (3/ago, o "pra trás" não voltava do zero) */
            if (dir < 0 && offset < 1) offset += loopW;
            if (dir > 0 && offset > loopW * 2 - 1) offset -= loopW;
            var o = offset;
            var bordas = tiles.map(function (t) { return t.offsetLeft; }).sort(function (a, c) { return a - c; });
            var alvo = null;
            if (dir > 0) {
              for (var i = 0; i < bordas.length; i++) if (bordas[i] > o + 0.5) { alvo = bordas[i]; break; }
              /* (4/ago) rede de segurança: se acabaram as bordas adiante, o
                 alvo é uma volta à frente da atual — o trilho nunca trava */
              if (alvo == null) alvo = o + loopW / Math.max(1, tiles.length / voltas);
            } else {
              for (var j = bordas.length - 1; j >= 0; j--) if (bordas[j] < o - 0.5) { alvo = bordas[j]; break; }
              if (alvo == null) alvo = o - loopW / Math.max(1, tiles.length / voltas);
            }
            if (alvo == null) return;
            animSeta = { de: o, para: alvo, t0: null, dur: 450 };
            v = 0;
            acorda();
          });
        });
      }

      /* ── sincronia: o motor manda, a fita e o trilho obedecem ──────────── */
      function sincroniza() {
        var k = chaveAtual();
        /* "estou em ambiente" se decide por IDENTIDADE, não por posição na
           fila — o índice quebrou quando o FRONTAL saiu da sequência (3/ago) */
        var emAmb = envs.some(function (e) { return e.id === k; });
        if (emAmb) ultimoEnv = k;
        Object.keys(chips).forEach(function (c) {
          chips[c].classList.toggle('is-on', c === k);
        });
        if (chipAmb) chipAmb.classList.toggle('is-on', emAmb);
        tiles.forEach(function (t) {
          t.classList.toggle('is-on', t.dataset.pdp26Chave === k);
        });
        if (window.__pdp26SyncTracos) window.__pdp26SyncTracos();
      }
      new MutationObserver(sincroniza).observe(mediaCol, { attributes: true, attributeFilter: ['class'] });
      var menuEl = raiz.querySelector('.jun26-env-dd__menu');
      if (menuEl) new MutationObserver(sincroniza).observe(menuEl, { attributes: true, subtree: true, attributeFilter: ['class'] });

      /* o frontal acompanha moldura/cor/tamanho e o palco acompanha a janela */
      vs.addEventListener('change', function () { requestAnimationFrame(pintaFrontal); });
      window.addEventListener('resize', function () { requestAnimationFrame(pintaFrontal); });

      /* ═══ MODO NARRADO (P26·47 — MARTELO 4/ago: "já adota aí, depois
         corrigimos"). O scroll da coluna dirige o palco; traços no lugar dos
         chips; resumo vivo no canto; setas só no ambiente; trilho e header
         fora de cena (CSS). Coluna intocada. ═══ */
      /* (5/ago, 2ª volta) QUEM SE AJUSTA É A FITA, NÃO O PALCO.
         A primeira versão mudava a ALTURA do palco conforme o scroll pra
         caber na dobra — e o conteúdo centrado dentro dele subia e descia
         junto: a obra dava um solavanco no meio da rolagem ("lombada").
         Agora o palco tem altura FIXA (a janela inteira) e a obra nunca se
         mexe; o que anda é o pé da fita, que sobe o tanto que o palco ainda
         estiver escondido atrás do header. Controle pode dançar — a obra não. */
      (function fitaNaDobra() {
        var fitaEl = raiz.querySelector('[data-pdp26-fita]');
        if (!fitaEl) return;
        /* (5/ago) A MEDIDA É SEMPRE DO MOMENTO, nunca cacheada.
           A versão anterior guardava a posição do palco na carga e subtraía o
           scroll. Se o layout mudasse depois (imagem chegando, fonte trocando),
           o número guardado ficava defasado — e num scroll rápido a fita subia
           pro MEIO do palco. Ler o rect a cada frame não tem esse risco, e não
           causa solavanco porque só a fita se mexe, nunca a obra.
           O teto de 160px é rede de segurança: qualquer conta maior que isso
           é erro, não layout. */
        /* (5/ago) TRANSFORM, NÃO `bottom`. Mexer em `bottom` a cada quadro
           dispara o `transition: all` que a fita herda: cada frame reiniciava
           uma transição nova e o controle PERSEGUIA o scroll com atraso —
           travava e depois caía de uma vez ("lag e depois desce"). Transform
           não reflui, não entra na transição herdada e acompanha o dedo 1:1. */
        var ajusta = function () {
          var r = mediaCol.getBoundingClientRect();
          fitaEl.style.setProperty('bottom', '22px', 'important');
          /* (5/ago) O PÉ TAMBÉM: a fita mora no pé do palco sticky, mas no
             VER QUADRO o BRANCO continua além dele (o vão até o trilho) — e a
             fita abandonava a rolagem ali, ainda com palco na tela. O alvo do
             pé passa a ser o FIM REAL da vista: no quadro, o topo do trilho
             (onde o branco acaba); no ambientado, o pé da foto (= o palco
             mesmo, que é o comportamento aprovado). Enquanto esse fim está
             além da dobra, a fita segura na dobra e acompanha o scroll;
             quando ele entra, ela desce junto e sai com a vista. */
          if (window.matchMedia('(min-width: 768px)').matches) {
            var emAmb = mediaCol.classList.contains('jun26-amb-on');
            var trilhoEl = document.querySelector('.pdp26-trilho');
            var fim = (!emAmb && trilhoEl) ? trilhoEl.getBoundingClientRect().top : r.bottom;
            var delta = Math.round(Math.min(window.innerHeight, fim) - r.bottom);
            /* teto de 160px na subida = rede de segurança de sempre */
            if (delta < -160) delta = -160;
            fitaEl.style.transform = delta ? 'translateY(' + delta + 'px)' : '';
          } else {
            var escondido = Math.min(160, Math.max(0, Math.round(r.top)));
            fitaEl.style.transform = escondido ? 'translateY(' + (-escondido) + 'px)' : '';
          }
        };
        /* (5/ago) SEGUIR ATÉ PARAR, não um quadro por evento de scroll.
           O header se esconde ANIMADO: depois que o dedo para, o topo do palco
           continua subindo por mais alguns quadros. Reagindo só ao evento de
           scroll, a fita lia um valor que ainda ia mudar e congelava ali — e
           só se acertava no scroll SEGUINTE ("dou um scroll e ele desce só
           depois de mais um"). Aqui ela persegue o valor até ele repetir. */
        /* (5/ago) O LAÇO PRECISA PARTIR. A versão anterior só o religava quando
           o contador JÁ tinha chegado a 6 — e ele nasce em 0, então cada scroll
           apenas o zerava e a perseguição nunca começava: a fita ficava com o
           transform da carga e descia presa ao pé do palco. `rodando` é a trava
           certa (uma corrente por vez); o contador só diz quando parar. */
        var seguindo = 0;
        var rodando = false;
        var seguir = function () {
          var antes = fitaEl.style.transform;
          ajusta();
          if (fitaEl.style.transform !== antes) seguindo = 0; else seguindo++;
          if (seguindo < 6) requestAnimationFrame(seguir);
          else rodando = false;
        };
        var acorda = function () {
          seguindo = 0;
          if (!rodando) { rodando = true; requestAnimationFrame(seguir); }
        };
        window.addEventListener('scroll', acorda, { passive: true });
        window.addEventListener('resize', ajusta);
        /* o layout do palco muda com a foto e com a troca de vista — refaz a
           conta quando ele muda de tamanho, não só quando a página rola */
        if ('ResizeObserver' in window) new ResizeObserver(ajusta).observe(mediaCol);
        window.addEventListener('load', ajusta);
        ajusta();
        /* na abertura o header ainda está assentando: a primeira conta saía
           32px curta e o primeiro toque no scroll corrigia de uma vez — um
           salto onde deveria haver continuidade. Duas repassadas resolvem. */
        setTimeout(ajusta, 300);
        setTimeout(ajusta, 900);
      })();

      /* (4/ago) auto-hide direcional: header some no scroll DOWN, volta no
         scroll UP e sempre aparece perto do topo. O antigo "toggle > 40"
         deixava o header escondido pra sempre até você voltar aos 40px, o
         que sumia com a nav sem forma de recuperar. Threshold pequeno pra
         não flicar com mini-jitters de trackpad. */
      var syncHeader = (function () {
        var lastY = window.scrollY;
        var TOPO = 40;
        var MIN = 6;
        return function () {
          var y = window.scrollY;
          var d = y - lastY;
          if (y <= TOPO) {
            document.documentElement.classList.remove('pdp26-header-off');
          } else if (d > MIN) {
            document.documentElement.classList.add('pdp26-header-off');
          } else if (d < -MIN) {
            document.documentElement.classList.remove('pdp26-header-off');
          }
          lastY = y;
        };
      })();
      window.addEventListener('scroll', syncHeader, { passive: true });
      syncHeader();

      /* (4/ago) mede o chrome (topbar+header) e publica em --pdp26-chrome —
         o CSS usa pra travar o palco sticky logo abaixo do header quando ele
         está visível (sem ficar atrás, como nas coleções). */
      (function medeChrome() {
        function mede() {
          /* --pdp26-chrome = só a parte que GRUDA (o header) — a topbar
             rola embora com a página, então usá-la na conta abria um gap de
             38px entre o header e o sticky no meio da página (4/ago, ao
             vivo). O total (topbar+header) vira --pdp26-chrome-total, que é
             o alvo do snap do primeiro scroll. */
          var gs = document.querySelectorAll('.shopify-section-group-header-group');
          var total = 0;
          [].slice.call(gs).forEach(function (g) { total += g.offsetHeight; });
          var hd = document.querySelector('.shopify-section-group-header-group.header-section') ||
                   document.querySelector('.shopify-section-group-header-group:has(.header)');
          var grudado = hd ? hd.offsetHeight : total;
          if (grudado > 0) document.documentElement.style.setProperty('--pdp26-chrome', grudado + 'px');
          if (total > 0) document.documentElement.style.setProperty('--pdp26-chrome-total', total + 'px');
        }
        mede();
        window.addEventListener('resize', mede);
        setTimeout(mede, 400);
      })();

      /* (4/ago) SNAP do primeiro scroll: um wheel pra baixo a partir do topo
         encaixa a página no estado "palco cheio" — chrome (topbar+header)
         fora da tela, coluna começando no artista. Um wheel pra cima perto
         do encaixe volta pro topo. Vale a tela inteira (os dois lados). */
      (function snapPrimeiroScroll() {
        var snapping = false;
        function alvoSnap() {
          /* alvo = altura TOTAL do chrome (topbar + header), a mesma medida
             publicada em --pdp26-chrome */
          var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pdp26-chrome'), 10);
          return v > 0 ? v : 124;
        }
        window.addEventListener('wheel', function (e) {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          /* (7/ago) o snap SAI DE CENA quando há painel aberto por cima. Ele
             barrava a roda enquanto a página estava no topo — e com a sacola
             aberta numa PDP isso comia toda rolagem da lista de artes: o
             `preventDefault` acontecia antes de o evento chegar ao drawer.
             Duas guardas porque são dois casos: painel aberto (classe no body)
             e cursor dentro de qualquer painel lateral. */
          if (document.body.classList.contains('side-panel-open')) return;
          if (e.target && e.target.closest && e.target.closest('.side-panel, cart-drawer, .cart-drawer')) return;
          var SNAP = alvoSnap();
          if (snapping) { e.preventDefault(); return; }
          if (e.deltaY > 0 && window.scrollY < SNAP - 4) {
            e.preventDefault();
            snapping = true;
            /* o chrome recolhe JUNTO com o scroll — sem isso o announcement
               rolava primeiro e o header ficava pra trás (4/ago, ao vivo) */
            document.documentElement.classList.add('pdp26-header-off');
            window.scrollTo({ top: SNAP, behavior: 'smooth' });
            setTimeout(function () { snapping = false; }, 520);
          } else if (e.deltaY < 0 && window.scrollY > 4 && window.scrollY <= SNAP + 60) {
            e.preventDefault();
            snapping = true;
            document.documentElement.classList.remove('pdp26-header-off');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(function () { snapping = false; }, 520);
          }
        }, { passive: false });
      })();

      (function modoNarrado() {
        /* 4/ago: DESLIGADO — o desktop NÃO muda (eu li o "adota" maior do que
           era; o narrado fica atrás desta flag pra ensaio). Desta seção, só o
           STICKY roda — esse foi pedido explícito ("pega esse sticky"). */
        var MODO_NARRADO = false;
        if (MODO_NARRADO) {
        raiz.classList.add('pdp26-narrado');
        document.documentElement.classList.add('pdp26-sem-header');

        /* — chrome do palco: ‹O + resumo | selo + sacola — */
        var chrome = document.createElement('div');
        chrome.className = 'pdp26-chrome';
        chrome.innerHTML =
          '<div class="pdp26-chrome__esq">' +
            '<button type="button" class="pdp26-chrome__voltar" aria-label="Voltar">' +
              '<svg class="pdp26-seta-g pdp26-seta-g--esq" viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true"><path d="m489.49 861.97-24.984-25.945 242.14-233.18-242.28-239.03 25.273-25.633 268.58 264.97z"/></svg>' +
              '<span class="pdp26-chrome__o">O</span>' +
            '</button>' +
            '<span class="pdp26-chrome__resumo" data-pdp26-resumo></span>' +
          '</div>' +
          '<div class="pdp26-chrome__dir">' +
            '<button type="button" class="pdp26-chrome__selo" aria-label="Salvar na lista"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5,4h14v15.5l-7-4-7,4V4Z" stroke="currentColor" stroke-width="1.35" stroke-miterlimit="8"/></svg></button>' +
            '<button type="button" class="pdp26-chrome__sacola" aria-label="Carrinho"><svg width="21" height="21" viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true"><path d="m780 348v-96h-360v96h-204v600h768v-600zm-300-36h240v36h-240zm444 576h-648v-480h144v60h60v-60h240v60h60v-60h144z"/></svg><span class="pdp26-chrome__n" data-pdp26-chrome-n hidden></span></button>' +
          '</div>';
        mediaCol.appendChild(chrome);
        /* voltar INTELIGENTE: histórico da própria loja; senão, a vitrine */
        chrome.querySelector('.pdp26-chrome__voltar').addEventListener('click', function () {
          if (document.referrer && document.referrer.indexOf(location.host) >= 0 && history.length > 1) history.back();
          else location.href = '/collections/all';
        });
        chrome.querySelector('.pdp26-chrome__selo').addEventListener('click', function () {
          var b = col.querySelector('[data-pdp26-save]');
          if (b) b.click();
        });
        chrome.querySelector('.pdp26-chrome__sacola').addEventListener('click', function () {
          var t = document.getElementById('cart-drawer-toggle');
          if (t) t.click();
        });
        /* número da sacola espelha o contador do header (que segue no DOM) */
        var nEl = chrome.querySelector('[data-pdp26-chrome-n]');
        var fonteN = document.querySelector('.header .thb-item-count');
        var syncN = function () {
          var v = fonteN ? fonteN.textContent.trim() : '';
          var vazio = !v || v === '0';
          nEl.hidden = vazio;
          if (!vazio) nEl.textContent = v;
        };
        if (fonteN) new MutationObserver(syncN).observe(fonteN, { childList: true, characterData: true, subtree: true });
        syncN();
        /* selo espelha o salvo */
        var syncSelo = function () {
          var on = col.querySelector('[data-pdp26-save][aria-pressed="true"]');
          chrome.querySelector('.pdp26-chrome__selo').classList.toggle('is-on', !!on);
        };
        new MutationObserver(syncSelo).observe(col, { attributes: true, subtree: true, attributeFilter: ['aria-pressed'] });
        syncSelo();

        /* — resumo vivo: escolhas + preço acompanham o palco — */
        var resumoEl = chrome.querySelector('[data-pdp26-resumo]');
        function pintaResumo() {
          var e = lerEstado();
          var d = medida(e.tamanho);
          var chaveTam = d ? (Math.round(d.w) + 'x' + Math.round(d.h)) : '';
          var sg = SIGLAS[chaveTam] ? SIGLAS[chaveTam] + ' ' : '';
          var partes = [NOME[e.primario] || e.primario];
          if (e.cor && e.cor !== 'sem moldura') partes.push(e.cor);
          if (d) partes.push(sg + d.w + ' × ' + d.h);
          /* (4/ago) SEM preço aqui — o preço mora no sticky lá embaixo; o
             canto do palco só ecoa as escolhas */
          resumoEl.innerHTML = '<span class="pdp26-chrome__r1">' + partes.join(' · ').toUpperCase() + '</span>';
        }
        vs.addEventListener('change', function () { setTimeout(pintaResumo, 80); });
        pintaResumo();

        /* — traços no lugar dos chips (indicador clicável) — */
        var tracos = document.createElement('div');
        tracos.className = 'pdp26-tracos';
        SEQ.forEach(function (k) {
          var t = document.createElement('button');
          t.type = 'button';
          t.className = 'pdp26-traco';
          t.dataset.pdp26Traco = k;
          var e = envs.filter(function (x) { return x.id === k; })[0];
          t.setAttribute('aria-label', k === 'perspectiva' ? 'Quadro' : rotulo(e || { label: k }));
          t.addEventListener('click', function () { manualNesta(); irPara(k); });
          tracos.appendChild(t);
        });
        fita.appendChild(tracos);
        window.__pdp26SyncTracos = function () {
          var k = chaveAtual();
          [].slice.call(tracos.children).forEach(function (t) {
            t.classList.toggle('is-on', t.dataset.pdp26Traco === k);
          });
        };
        window.__pdp26SyncTracos();

        /* — o narrador: a seção ativa da coluna decide a vista, ATÉ a mão
           tocar; gesto manual cala o automático até a seção trocar — */
        function secaoAtual() {
          /* enquanto MOLDURA E COR ainda ocupa o foco (terço de cima), a
             história é perspectiva; quando ela sobe e sai, o tamanho assume
             e o palco vira ambiente. (fsTam era o critério e abria a página
             já no ambientado — a coluna é compacta demais pra ele.) */
          var r = fsMold.getBoundingClientRect();
          return (r.bottom < window.innerHeight * 0.3) ? 'tam' : 'mold';
        }
        var secaoManual = null;
        function manualNesta() { secaoManual = secaoAtual(); }
        [].slice.call(fita.querySelectorAll('[data-pdp26-fita-seta]')).forEach(function (b) {
          b.addEventListener('click', manualNesta);
        });
        }

        /* — STICKY de compra (P26·23, "pega esse sticky"): barra tinta no pé
           da COLUNA com preço + PIX + ADICIONAR; some quando o CTA real está
           na tela (senão é eco). Valores espelham os da coluna. — */
        var sticky = document.createElement('div');
        sticky.className = 'pdp26-sticky';
        /* (4/ago, 2ª volta) versão DESKTOP: barra CINZA do palco com a
           MINIATURA DA ARTE EMOLDURADA (a moldura diz a cor — swatch morreu),
           NOME DA ARTE em serif, escolhas, preço+PIX e ADICIONAR preto */
        /* (4/ago, 3ª volta) SEM título — só as opções, na IDENTIDADE da
           coluna: ícone/swatch + nome + chevron; sigla em SELO preto DEPOIS
           do tamanho. Clicar num item rola até a opção correspondente. */
        /* (6/ago) o CHEVRON saiu — três setinhas viravam ruído numa barra que
           já fala por legenda+valor; o clique continua rolando até a opção.
           Os fios verticais entre os grupos saíram junto (ver CSS): o
           espaçamento é o separador, como na fileira de ícones do header. */
        /* cada opção = LEGENDA caps por cima + valor embaixo (a língua do
           recibo da coluna); o quadrado vazio do acabamento saiu — a legenda
           já nomeia (4/ago, "deixa mais bonito") */
        /* data-no-relabel: sem isso o reescritor global do theme.liquid troca
           a legenda "Tamanho" por "Tamanho:" — e só ela ganhava dois-pontos */
        function opHTML(k, legenda, miolo) {
          return '<button type="button" class="pdp26-sticky__op" data-pdp26-sticky-op="' + k + '">' +
            '<span class="pdp26-sticky__op-in">' +
              '<span class="pdp26-sticky__op-leg" data-no-relabel>' + legenda + '</span>' +
              '<span class="pdp26-sticky__op-val">' + miolo + '</span>' +
            '</span></button>';
        }
        /* (5/ago) SEM ÍCONE nas opções de moldura e tamanho: o quadradinho
           vazio e o esquadro não diziam nada que a LEGENDA já não diga —
           eram enfeite. Só a COR mantém o swatch, porque ali o símbolo É a
           informação (a cor não se escreve). */
        sticky.innerHTML =
          '<i class="pdp26-sticky__mini" data-pdp26-sticky-mini></i>' +
          '<div class="pdp26-sticky__ops">' +
            opHTML('mold', 'Moldura', '<span data-pdp26-sticky-mold></span>') +
            opHTML('cor', 'Cor', '<i class="pdp26-sticky__op-sw" data-pdp26-sticky-cor-sw></i><span data-pdp26-sticky-cor></span>') +
            opHTML('tam', 'Tamanho', '<span data-pdp26-sticky-tam></span><b class="pdp26-sticky__sigla" data-pdp26-sticky-sigla hidden></b>') +
          '</div>' +
          '<span class="pdp26-sticky__vao"></span>' +
          /* (13/ago, ao vivo) SALVAR e CONSULTOR saem do sticky — ele fica com o
             essencial: miniatura, opções, preço e o Adicionar ao carrinho */
          '<div class="pdp26-sticky__precos">' +
            '<div class="pdp26-sticky__v" data-pdp26-sticky-preco></div>' +
            '<div class="pdp26-sticky__sub" data-pdp26-sticky-sub></div>' +
          '</div>' +
          '<button type="button" class="pdp26-sticky__cta">Adicionar ao carrinho</button>';
        raiz.querySelector('.pdp26-coluna').appendChild(sticky);
        var ctaReal = col.querySelector('.single-add-to-cart-button');
        sticky.querySelector('.pdp26-sticky__cta').addEventListener('click', function () {
          if (ctaReal) ctaReal.click();
        });
        /* (6/ago) O SALVAR DO STICKY GANHA ESTADO. O clique sempre salvou de
           verdade (reencaminha pro bookmark da manchete → app), mas o botão
           daqui não contava: seguia "Salvar" de bookmark vazio, e parecia que
           nada tinha acontecido. Com data-pdp26-save o pintarSave passa a
           pintá-lo junto (aria-pressed + rótulo "Salvo"); o repouso do rótulo
           é semeado aqui porque a varredura inicial rodou antes de o sticky
           existir. Bookmark cheio via CSS no aria-pressed. */
        (function () {
          var svLbl = sticky.querySelector('[data-pdp26-sticky-save] [data-pdp26-save-label]');
          if (svLbl) svLbl.setAttribute('data-pdp26-save-repouso', svLbl.textContent.trim());
        })();
        /* (13/ago) o Salvar saiu do sticky — o listener fica condicionado à
           existência do botão, para o dia em que ele voltar */
        var stickySave = sticky.querySelector('[data-pdp26-sticky-save]');
        if (stickySave) stickySave.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var b = col.querySelector('.pdp26-icone--save[data-pdp26-save], [data-pdp26-save]:not([data-pdp26-sticky-save])');
          if (b) b.click();
        });
        /* (13/ago) o consultor também saiu do sticky — listener condicionado */
        var stickyMsg = sticky.querySelector('[data-pdp26-sticky-msg]');
        if (stickyMsg) stickyMsg.addEventListener('click', function () {
          var c = col.querySelector('.pdp26-consultor a, .pdp26-consultor button');
          if (c) c.click();
        });
        /* (6/ago) o consultor do sticky segue A MESMA REGRA da coluna: o ponto
           espelha o estado do [data-pdp26-presenca] (verde pulsando = online,
           preto respirando devagar = fora do horário) e o texto vem do mesmo
           rótulo ("Fale com um consultor" / "Deixe uma mensagem"). Antes era
           verde fixo com frase fixa — mentia atendimento de madrugada. */
        (function () {
          var ptCol = col.querySelector('[data-pdp26-presenca]');
          var txCol = col.querySelector('[data-pdp26-consultor-txt]');
          var ptStk = sticky.querySelector('.pdp26-sticky__ponto');
          var txStk = sticky.querySelector('[data-pdp26-sticky-msg-txt]');
          if (ptCol && ptStk) ptStk.classList.toggle('is-on', ptCol.classList.contains('is-on'));
          if (txCol && txStk) txStk.textContent = txCol.textContent.trim();
        })();
        function pintaSticky() {
          var p = col.querySelector('[data-pdp26-valor="preco"]');
          var pix = col.querySelector('[data-pdp26-valor="pix"]');
          sticky.querySelector('[data-pdp26-sticky-preco]').textContent = p ? p.textContent.trim() : '';
          /* (4/ago) só o PIX no sticky — o "12x no cartão" já está no bloco
             de preço da coluna e repetido aqui só engordava a linha */
          /* (6/ago) a linha fala a MESMA língua do bloco de preço: valor em
             verde, "no PIX" em cinza, selo −10% na pílula verde — antes era
             um número cinza nu, que não dizia de onde vinha o desconto */
          var off = col.querySelector('[data-pdp26-valor="pixoff"]');
          sticky.querySelector('[data-pdp26-sticky-sub]').innerHTML =
            (pix ? '<span class="pdp26-sticky__pixv">' + pix.textContent.trim() + '</span>' +
                   '<span class="pdp26-sticky__pixsuf">no PIX</span>' +
                   (off && off.textContent.trim() ? '<span class="pdp26-sticky__pixoff">' + off.textContent.trim() + '</span>' : '')
                 : '');
          /* as opções na identidade da coluna; a MINIATURA veste a moldura
             da cor escolhida (sem moldura = arte nua) */
          var e = lerEstado();
          function titulo1(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
          sticky.querySelector('[data-pdp26-sticky-mold]').textContent = NOME[e.primario] || titulo1(e.primario);
          var opCor = sticky.querySelector('[data-pdp26-sticky-op="cor"]');
          if (e.cor && e.cor !== 'sem moldura') {
            opCor.hidden = false;
            sticky.querySelector('[data-pdp26-sticky-cor]').textContent = titulo1(e.cor);
            sticky.querySelector('[data-pdp26-sticky-cor-sw]').style.background = PERFIL[e.cor] || '#C9A876';
          } else opCor.hidden = true;
          var d = medida(e.tamanho);
          sticky.querySelector('[data-pdp26-sticky-tam]').textContent = d ? (d.w + ' × ' + d.h) : '';
          var sig = sticky.querySelector('[data-pdp26-sticky-sigla]');
          var sgl = d && SIGLAS[Math.round(d.w) + 'x' + Math.round(d.h)];
          sig.hidden = !sgl;
          if (sgl) sig.textContent = sgl;
          var mini = sticky.querySelector('[data-pdp26-sticky-mini]');
          var art = raiz.querySelector('.pp26__slide--perspective .pp26__art');
          if (art && art.src) mini.style.backgroundImage = 'url("' + (art.currentSrc || art.src) + '")';
          mini.style.borderWidth = (e.primario === 'sem moldura') ? '0' : '3px';
          mini.style.borderColor = PERFIL[e.cor] || PERFIL['madeira clara'];
          /* (13/ago) a MINI respeita a PROPORÇÃO da arte — no retrato fixo
             40×54 um quadro quadrado saía esticado ("quadrado não tá quadrado") */
          if (d && d.w > 0 && d.h > 0) {
            mini.style.height = Math.max(28, Math.min(54, Math.round(40 * d.h / d.w))) + 'px';
          }
        }
        /* chevron honesto: clicar no item rola até a opção correspondente */
        [].slice.call(sticky.querySelectorAll('[data-pdp26-sticky-op]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var alvo = { mold: fsMold, cor: fsCor, tam: fsTam }[b.dataset.pdp26StickyOp];
            if (alvo) alvo.scrollIntoView({ block: 'center', behavior: 'smooth' });
          });
        });
        vs.addEventListener('change', function () { setTimeout(pintaSticky, 80); });
        pintaSticky();
        /* (4/ago, regra final do dono) o sticky SÓ existe depois que o
           ADICIONAR real ficou PRA CIMA da janela — nunca antes dele, e
           nunca com o preço à vista (o CTA fica abaixo do preço, então um
           critério cobre os dois) */
        var decideSticky = function () {
          if (!ctaReal) return;
          sticky.classList.toggle('is-off', ctaReal.getBoundingClientRect().bottom >= 0);
        };
        window.addEventListener('scroll', function () { requestAnimationFrame(decideSticky); }, { passive: true });
        decideSticky();
        /* a bolinha do carregando também no sticky */
        if (ctaReal) {
          new MutationObserver(function () {
            sticky.querySelector('.pdp26-sticky__cta').classList.toggle('loading', ctaReal.classList.contains('loading'));
          }).observe(ctaReal, { attributes: true, attributeFilter: ['class'] });
        }

        if (!MODO_NARRADO) return;
        var ultimaSecao = secaoAtual();
        function narra() {
          /* narrador só fala com o palco ANCORADO — se ele já está saindo da
             janela (monitor alto, coluna inteira à vista), trocar vista é
             barulho (4/ago) */
          if (mediaCol.getBoundingClientRect().top < -2) return;
          var s = secaoAtual();
          if (s !== ultimaSecao) { ultimaSecao = s; if (secaoManual !== s) secaoManual = null; }
          if (secaoManual === s) return;
          var querAmb = (s === 'tam');
          var estaAmb = mediaCol.classList.contains('jun26-amb-on');
          if (querAmb && !estaAmb) irPara(ultimoEnv || (envs[0] && envs[0].id));
          else if (!querAmb && estaAmb) irPara('perspectiva');
        }
        window.addEventListener('scroll', function () { requestAnimationFrame(narra); }, { passive: true });
        narra();
      })();

      sincroniza();
    });
  })();
})();

/* ═══ CONTROLE DE ALTURA DO PALCO (4/ago) — só com ?palco=1 na URL ════════
   Três tamanhos pra decidir no olho qual é o certo no mobile. O valor entra
   na variável --pdp26-palco-h e o painel mostra a altura resultante em px e
   em vh. A escolha fica no localStorage, então sobrevive ao reload enquanto
   você compara. Nada disso existe sem o parâmetro na URL. */
(function controlePalco() {
  if (!/[?&]palco=1/.test(location.search)) return;

  var TAMANHOS = [
    { id: 'P', rotulo: 'Pequeno', valor: '48vh' },
    { id: 'M', rotulo: 'Médio',   valor: '62vh' },
    { id: 'G', rotulo: 'Grande',  valor: '74vh' }
  ];

  /* a variável mora na RAIZ (a coluna também a consome pra reservar espaço) */
  function palco() { return document.querySelector('.thb-product-detail--pdp2026'); }

  function aplica(v) {
    var p = palco();
    if (p) p.style.setProperty('--pdp26-palco-h', v);
    try { localStorage.setItem('pdp26-palco-h', v); } catch (e) {}
    pinta();
  }

  var caixa, saida;
  function pinta() {
    if (!saida) return;
    var g = document.querySelector('.pp26-gallery');
    var h = g ? Math.round(g.getBoundingClientRect().height) : 0;
    var vh = window.innerHeight ? (h / window.innerHeight * 100).toFixed(0) : '?';
    saida.textContent = h + 'px · ' + vh + 'vh';
    var atual = (palco() && palco().style.getPropertyValue('--pdp26-palco-h')) || '62vh';
    [].slice.call(caixa.querySelectorAll('button')).forEach(function (b) {
      var on = b.dataset.v === atual.trim();
      /* ativo = branco cheio; inativo = vazado. (O inverso sumia contra o
         fundo preto do painel e dava pra ler o ativo como desligado.) */
      b.style.background = on ? '#FFFFFF' : 'transparent';
      b.style.color = on ? '#161310' : 'rgba(255,255,255,.75)';
      b.style.boxShadow = on ? 'none' : 'inset 0 0 0 1px rgba(255,255,255,.35)';
    });
  }

  function monta() {
    if (caixa) return;
    caixa = document.createElement('div');
    caixa.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:2147483647;' +
      'background:#161310;color:#fff;padding:8px;border-radius:6px;' +
      'font:11px/1.4 ui-monospace,monospace;display:flex;gap:6px;align-items:center';
    TAMANHOS.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.v = t.valor;
      b.textContent = t.id;
      b.title = t.rotulo + ' (' + t.valor + ')';
      b.style.cssText = 'width:26px;height:26px;border:0;cursor:pointer;font:inherit;font-weight:600';
      b.addEventListener('click', function () { aplica(t.valor); });
      caixa.appendChild(b);
    });
    saida = document.createElement('span');
    saida.style.cssText = 'margin-left:4px;opacity:.85';
    caixa.appendChild(saida);
    document.body.appendChild(caixa);

    var salvo = null;
    try { salvo = localStorage.getItem('pdp26-palco-h'); } catch (e) {}
    if (salvo) aplica(salvo); else pinta();
  }

  window.addEventListener('load', monta);
  window.addEventListener('resize', pinta);
  setTimeout(monta, 900);
})();

/* ═══ DOTS DE VISTA — MOBILE (4/ago) ══════════════════════════════════════
   No celular os chips PERSPECTIVA · AMBIENTADO custavam caro: comiam ~55px
   de altura do palco e, pior, estavam MORTOS — a fatia 3 que os liga é
   desktop-only, então clicar neles não fazia nada. Aqui eles dão lugar a uma
   fileira de bolinhas: uma por vista (perspectiva + cada ambiente), do
   tamanho de um ponto, com a ativa preenchida. Compacto, universal e — ao
   contrário dos chips — funcional: cada dot chama o setMode da ponte
   window.__pdp26Amb, o mesmo motor que o desktop usa. */
(function dotsVistaMobile() {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  function comPalco(cb) {
    if (window.__pdp26Amb) return cb(window.__pdp26Amb);
    raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
  }

  comPalco(function (palco) {
    if (!palco || typeof palco.setMode !== 'function') return;
    var fita = raiz.querySelector('[data-pdp26-fita]');
    if (!fita || fita.querySelector('[data-pdp26-dots]')) return;

    /* a sequência espelha a do desktop: o quadro primeiro, os ambientes depois */
    var SEQ = [{ id: 'quadro', nome: 'Quadro' }].concat(
      (palco.envs || []).map(function (e) {
        var s = String(e.label || e.id || '');
        return { id: e.id, nome: s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() };
      })
    );
    if (SEQ.length < 2) return;

    var caixa = document.createElement('div');
    caixa.className = 'pdp26-dots';
    caixa.setAttribute('data-pdp26-dots', '');
    caixa.setAttribute('role', 'tablist');
    caixa.setAttribute('aria-label', 'Vistas da obra');

    SEQ.forEach(function (v) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'pdp26-dot';
      d.dataset.vista = v.id;
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', v.nome);
      d.addEventListener('click', function () {
        /* vai() é a máquina de transição (com o crossfade do mobile);
           setMode cru fica de reserva pra quando ela recusa */
        if (!(palco.vai && palco.vai(v.id))) palco.setMode(v.id);
        setTimeout(pinta, 60);
      });
      caixa.appendChild(d);
    });
    fita.appendChild(caixa);

    /* ═══ CURSOR DESLIZANTE (4/ago) ═══
       "mas essa barrinha não vai deslizando também?" — vai: os traços viram
       TRILHA e o indicador é uma peça única que desliza até o segmento
       ativo. É a linguagem de slider que a barra pedia — e mover chrome de
       UI não fere a regra do quadro: aqui o movimento é o significado. */
    caixa.style.position = 'relative';
    var cursor = document.createElement('div');
    cursor.setAttribute('aria-hidden', 'true');
    cursor.style.cssText = 'position:absolute;left:0;bottom:0;height:2px;'
      + 'width:' + (100 / SEQ.length) + '%;background:#161310;pointer-events:none;'
      + 'transition:transform .34s cubic-bezier(.33,0,.2,1);';
    caixa.appendChild(cursor);

    /* o palco inteiro escuta toque pra dar ZOOM, e a barra vive dentro dele:
       sem barreira, tocar num traço abria o zoom e só depois trocava a cena
       (4/ago, ao vivo: "se eu clico na barra aparece o zoom, depois muda de
       slide"). A barreira fica na fase de BOLHA — em captura ela mataria o
       evento antes de chegar ao próprio traço, que é o erro que a barra do
       topo já cometeu uma vez. */
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (ev) {
      caixa.addEventListener(ev, function (e) { e.stopPropagation(); }, false);
    });

    /* ═══ SCRUBBER (4/ago, escolha do Rafael) ═══
       A barra é uma timeline: o dedo desliza por ela e as cenas viram em
       CORTE SECO, acompanhando a posição — flipbook, não fila de fades
       (fade atrás do dedo vira lag; corte não move quadro, então respeita a
       regra). Também é a resposta ao conflito com o scroll: navegar aqui
       não disputa com a rolagem da página, diferente do swipe no palco. */
    /* pan-y, não none: com none, a rolagem vertical que COMEÇASSE na barra
       morria ("aqui eu não consigo [rolar]") — e a área de dedo de 20px pega
       um pedaço nobre do polegar. pan-y entrega o eixo X pro scrubber e
       devolve o Y pra página (o pointercancel desarma o scrub no caminho). */
    caixa.style.touchAction = 'pan-y';
    var scrubAtivo = false, scrubUlt = -1;
    /* ═══ O SCRUB PUXA A IMAGEM (4/ago) ═══
       "se eu deslizar 10, 20 ou 40% não vai fazer diferença... isso não pode"
       — agora faz: a barra dirige a MÁQUINA DE DESLIZE (palco.arrastaBar,
       a mesma alavanca do arrasto) com progresso contínuo. 30% de segmento
       varrido = 30% da cena seguinte puxada pra dentro. Cruzou a fronteira,
       commit e segue; voltou, devolve. Ao soltar no meio, fecha pra borda
       mais próxima. Se a máquina estiver ocupada (varredura muito rápida),
       degrada pro corte seco — nunca trava na mão. */
    var sb = null, sbSt = null, sbDe = -1, sbDir = 0;
    function posP(clientX, rc) {
      var f = (clientX - rc.left) / rc.width;
      return Math.max(0, Math.min(0.9999, f)) * SEQ.length;
    }
    function scrubPara(clientX) {
      var rc = caixa.getBoundingClientRect();
      if (!rc.width) return;
      if (sb === null && palco.arrastaBar) sb = palco.arrastaBar;
      var cw = rc.width / SEQ.length;
      var px = Math.max(0, Math.min(rc.width - cw, clientX - rc.left - cw / 2));
      cursor.style.transition = 'none';
      cursor.style.transform = 'translateX(' + px.toFixed(1) + 'px)';

      var p = posP(clientX, rc);
      if (!sb) {
        /* ponte antiga sem alavanca: mantém o corte por segmento */
        var iC = Math.floor(p);
        if (iC !== scrubUlt) { scrubUlt = iC; palco.setMode(SEQ[iC].id); setTimeout(pinta, 30); }
        return;
      }

      var passos = 0;
      while (passos++ < 6) {
        if (sbSt) {
          var ef = sbDir > 0 ? (p - sbDe) : (sbDe - p);
          if (ef >= 1) { sb.solta(sbSt, true); sbSt = null; continue; }
          if (ef <= 0) { sb.solta(sbSt, false); sbSt = null; continue; }
          sb.move(sbSt, -sbDir * ef * sb.w());
          return;
        }
        var c = sb.idx();
        var alvoDir = p > c + 0.02 ? 1 : (p < c - 0.02 ? -1 : 0);
        if (!alvoDir) return;
        var alvo = c + alvoDir;
        if (alvo < 0 || alvo >= SEQ.length) return;
        sbSt = sb.comeca(alvo, alvoDir);
        if (!sbSt) {
          /* ocupada: corte seco pro segmento do dedo e segue a vida */
          var iQ = Math.floor(p);
          if (iQ !== c) palco.setMode(SEQ[iQ].id);
          return;
        }
        sbDe = c; sbDir = alvoDir;
      }
    }
    caixa.addEventListener('pointerdown', function (e) {
      scrubAtivo = true; scrubUlt = -1;
      try { caixa.setPointerCapture(e.pointerId); } catch (x) {}
      scrubPara(e.clientX);
    });
    caixa.addEventListener('pointermove', function (e) { if (scrubAtivo) scrubPara(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      caixa.addEventListener(ev, function (e) {
        scrubAtivo = false;
        if (sbSt && sb) {
          var rc = caixa.getBoundingClientRect();
          var p = posP(e.clientX || 0, rc);
          var ef = sbDir > 0 ? (p - sbDe) : (sbDe - p);
          sb.solta(sbSt, ef > 0.5);
          sbSt = null;
        }
        cursor.style.transition = '';
        setTimeout(pinta, 380);
      });
    });

    function pinta() {
      var atual = typeof palco.modo === 'function' ? palco.modo() : 'quadro';
      var idx = 0;
      [].slice.call(caixa.querySelectorAll('.pdp26-dot')).forEach(function (d, i) {
        var on = d.dataset.vista === atual;
        if (on) idx = i;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* durante o scrub quem manda no cursor é o dedo */
      if (!scrubAtivo) cursor.style.transform = 'translateX(' + (idx * 100) + '%)';
    }
    pinta();

    /* O palco troca de vista por vários caminhos — dot, swipe, escolha de
       tamanho, setas. Observar `class` cobria só parte deles: no SWIPE a
       classe não muda, e a barra ficava parada na primeira cena (4/ago, ao
       vivo: "na segunda imagem não mexeu lá embaixo"). Em vez de caçar cada
       gatilho, a fonte da verdade é consultada direto: se o modo mudou, a
       barra repinta. Barato — é uma leitura de string. */
    try {
      var alvo = raiz.querySelector('.pp26-product-grid__media');
      if (alvo) new MutationObserver(pinta).observe(alvo, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    window.addEventListener('resize', pinta);

    var ultimo = null;
    (function vigia() {
      var m = typeof palco.modo === 'function' ? palco.modo() : null;
      if (m !== ultimo) { ultimo = m; pinta(); }
      requestAnimationFrame(vigia);
    })();
  });
})();

/* ═══ A ESCOLHA LEVA À VISTA QUE A MOSTRA (4/ago, mobile) ═════════════════
   Cada decisão da coluna se prova numa vista diferente do palco, e trocar
   à mão toda vez é atrito puro:

     · MOLDURA e COR → perspectiva. O perfil, a espessura e o veio da
       madeira só existem no PNG em ângulo; no ambiente, a moldura vira
       um traço de poucos pixels na parede.
     · TAMANHO → ambiente. Ninguém escolhe "M" no absoluto — escolhe M em
       relação à parede, ao sofá, à cabeceira. Fora de escala, os cinco
       chips são só números.

   Só age no mobile: no desktop o palco e a coluna convivem na mesma tela,
   então a pessoa já vê a mudança sem que nada se mexa por baixo dela. */
(function vistaSegueEscolha() {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  function comPalco(cb) {
    if (window.__pdp26Amb) return cb(window.__pdp26Amb);
    raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
  }

  comPalco(function (palco) {
    if (!palco || typeof palco.setMode !== 'function') return;

    var PERSPECTIVA = ['escolha-o-tipo-de-moldura', 'escolha-a-cor-da-moldura'];
    var AMBIENTE = ['escolha-o-tamanho-(cm)'];

    function opcaoDe(alvo) {
      var bloco = alvo.closest && alvo.closest('[data-pdp26-opcao]');
      return bloco ? bloco.getAttribute('data-pdp26-opcao') : null;
    }

    raiz.addEventListener('change', function (e) {
      var op = opcaoDe(e.target);
      if (!op) return;

      if (PERSPECTIVA.indexOf(op) > -1) {
        /* sempre volta, mesmo que a pessoa esteja num ambiente: é lá que a
           moldura escolhida aparece de verdade (4/ago, confirmado ao vivo) */
        palco.setMode('quadro');
        return;
      }

      if (AMBIENTE.indexOf(op) > -1) {
        /* já num ambiente? fica onde está — trocar de cômodo no meio da
           comparação de tamanho seria pior que não fazer nada. */
        if (palco.modo && palco.modo() !== 'quadro') return;
        var primeiro = (palco.envs && palco.envs[0]) ? palco.envs[0].id : null;
        if (primeiro) palco.setMode(primeiro);
      }
    }, true);
  });
})();

/* ═══ FRESTA DA PRÓXIMA CENA (4/ago, mobile) ══════════════════════════════
   Uma faixa estreita na borda direita mostrando o começo da próxima vista.
   É o que conta que existe mais coisa adiante e o que convida o dedo —
   sem ela, a barra de progresso é a única pista, e ela é discreta demais
   pra puxar um gesto.

   O peek do tema (.jun26-amb--peek) não serve aqui: ele é criado durante o
   arrasto e destruído no fim, então não existe em repouso. Este é próprio,
   permanente, e vive de background-image — a mesma URL que o motor usa,
   então quando a pessoa passar pra cena ela já está no cache do navegador. */
/* ═══ CENAS PRÉ-AQUECIDAS (4/ago, mobile) ════════════════════════════════
   Pedido do Rafael: os quadros renderizados JÁ na posição deles, para cada
   tamanho — a cena tem que abrir resolvida, nada se mexendo na chegada.
   O pulo da abertura tinha duas fontes:
   1. A foto da cena só era baixada/decodificada no gesto — a âncora do
      quadro é calculada contra a imagem, então nascia errada e corrigia
      quando a foto chegava. Pré-baixar E pré-decodificar mata isso: com
      img.complete, a âncora sai certa no primeiro frame.
   2. Trocado o tamanho da arte, a geometria nova do quadro nas cenas só era
      calculada na próxima abertura — visível. Um pinta() depois que o motor
      assenta faz essa conta ANTES, com a cena ainda fora de vista. */
(function preAqueceCenas() {
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  function comPalco(cb) {
    if (window.__pdp26Amb) return cb(window.__pdp26Amb);
    raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
  }

  comPalco(function (palco) {
    if (!palco || !palco.envs || !palco.envs.length) return;

    /* imediato, a pedido ("se puder ser sem o delay"): as cenas entram na
       fila assim que o palco está pronto, uma a uma pra não saturar a rede,
       cada uma já decodificada ao sair da fila */
    var i = 0;
    function proxima() {
      if (i >= palco.envs.length) return;
      var src = palco.srcDe(palco.envs[i]);
      i++;
      if (!src) { proxima(); return; }
      var img = new Image();
      img.src = src;
      var segue = function () { proxima(); };
      if (img.decode) img.decode().then(segue, segue);
      else { img.onload = segue; img.onerror = segue; }
    }
    proxima();

    /* tamanho trocado: repinta com a cena ainda fora de vista, pra âncora
       nova já existir quando a pessoa abrir — no frame seguinte ao repaint
       do próprio motor */
    raiz.addEventListener('change', function () {
      clearTimeout(preAqueceCenas.__t);
      preAqueceCenas.__t = setTimeout(function () {
        try { if (palco.pinta) palco.pinta(); } catch (e) {}
      }, 120);
    }, true);
  });
})();

(function frestaProximaCena() {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  function comPalco(cb) {
    if (window.__pdp26Amb) return cb(window.__pdp26Amb);
    raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
  }

  comPalco(function (palco) {
    if (!palco || !palco.envs || !palco.envs.length) return;
    var media = raiz.querySelector('.pp26-product-grid__media');
    if (!media || media.querySelector('[data-pdp26-fresta]')) return;

    var SEQ = ['quadro'].concat(palco.envs.map(function (e) { return e.id; }));

    var fresta = document.createElement('div');
    fresta.className = 'pdp26-fresta';
    fresta.setAttribute('data-pdp26-fresta', '');
    fresta.setAttribute('aria-hidden', 'true');
    media.appendChild(fresta);

    function proxima() {
      var atual = typeof palco.modo === 'function' ? palco.modo() : 'quadro';
      var i = SEQ.indexOf(atual);
      /* (4/ago) a fresta convida em TODOS os slides MENOS no último: dar a
         volta prometia continuação onde a sequência termina ("quero isso em
         todos os slides... tirando o último"). No fim, sem fresta — a
         barrinha e o swipe voltam. */
      if (i >= SEQ.length - 1) return null;
      return SEQ[i + 1];
    }

    /* a perspectiva não é foto de cena: o que aparece na fresta é a própria
       obra renderizada no palco. Assim o ciclo fecha com imagem em todas as
       posições, inclusive na volta do último ambiente pra perspectiva
       (4/ago: "sempre tenha uma imagem visível, que nem a primeira"). */
    function srcDaPerspectiva() {
      var img = raiz.querySelector('.pp26-gallery__slide img, .pp26__slide img, .pp26-gallery img');
      return img ? (img.currentSrc || img.src || null) : null;
    }

    var ultimoSrc = null;
    function pinta() {
      var alvo = proxima();
      var src = null;

      if (alvo === 'quadro') {
        src = srcDaPerspectiva();
      } else {
        for (var k = 0; k < palco.envs.length; k++) {
          if (palco.envs[k].id === alvo) { src = palco.srcDe(palco.envs[k]); break; }
        }
      }

      if (!src) { fresta.style.display = 'none'; return; }
      fresta.style.display = '';
      fresta.classList.toggle('pdp26-fresta--obra', alvo === 'quadro');
      if (src !== ultimoSrc) {
        ultimoSrc = src;
        fresta.style.backgroundImage = 'url("' + src + '")';
      }
    }
    pinta();

    /* segue o modo pelo mesmo caminho da barra: leitura direta, sem
       depender de qual gesto causou a troca */
    var ultimo = null;
    (function vigia() {
      var m = typeof palco.modo === 'function' ? palco.modo() : null;
      if (m !== ultimo) { ultimo = m; pinta(); }
      requestAnimationFrame(vigia);
    })();

    /* (22/ago) XERIFE DO REPOUSO: gesto interrompido no meio da troca
       deixava o palco pela metade — cena fantasma com display ligado sob a
       perspectiva (o "degradê" na volta do 2º slide pro 1º, visto ao vivo)
       e a classe jun26-amb-on fora do lugar (glifos em tinta sobre foto).
       O motor da troca é do jun26 e segue intocado; aqui só se garante o
       INVARIANTE do estado PARADO: 800ms depois de o modo assentar,
       quadro = nenhuma cena visível e sem amb-on; ambiente = amb-on de pé.
       Se o motor estiver no meio de outra troca, o modo terá mudado e o
       timer se descarta sozinho. */
    var xerifeTimer = null, xerifeUltimo = null;
    (function xerife() {
      var m = typeof palco.modo === 'function' ? palco.modo() : null;
      if (m !== xerifeUltimo) {
        xerifeUltimo = m;
        clearTimeout(xerifeTimer);
        xerifeTimer = setTimeout(function () {
          var agora = typeof palco.modo === 'function' ? palco.modo() : null;
          if (agora !== m) return;
          media.classList.toggle('jun26-amb-on', m !== 'quadro');
          if (m === 'quadro') {
            [].slice.call(media.querySelectorAll('.jun26-amb')).forEach(function (a) {
              if (getComputedStyle(a).display !== 'none') a.style.display = 'none';
            });
          }
        }, 600);
      }
      requestAnimationFrame(xerife);
    })();

    /* tocar na fresta avança — quem repara nela espera que ela leve adiante */
    fresta.style.pointerEvents = 'auto';
    fresta.addEventListener('click', function (e) {
      e.stopPropagation();
      var alvo = proxima();
      if (!alvo) return;
      /* mesmo desvio dos traços: a máquina anima; setMode cru é o reserva */
      if (!(palco.vai && palco.vai(alvo))) palco.setMode(alvo);
    });
  });
})();

/* ═══ GRIP — REMOVIDO (4/ago) ═════════════════════════════════════════════
   A alça de arrastar a folha sobre o palco foi construída e recuada no
   mesmo dia, a pedido do dono. Com o palco FIXO em 30% e a cena trocando
   por swipe/roda, ela virava um terceiro gesto disputando a mesma região
   da tela — e sem resposta óbvia sobre o que aconteceria ao soltar.
   A altura segue ajustável pelo controle de desenvolvimento ?palco=1. */

/* ═══ PALCO FIXO, COM SAÍDA NO RODAPÉ (4/ago, mobile) ═════════════════════
   `sticky` grudava só enquanto a grade pai tinha espaço: passado o fim da
   folha, a obra se soltava e sumia. Com `fixed` ela fica presa ao topo o
   tempo todo — acompanha moldura, cor, tamanho, preço e CTA sem falhar.

   Só que ela não deve acompanhar TUDO: quando começa o texto de SEO e o
   rodapé, o assunto deixa de ser aquela peça, e 30% da tela ocupados por
   ela viram desperdício. Então a obra desliza pra fora ao ver o rodapé
   chegar, e volta se a pessoa subir. Quem decide é um IntersectionObserver
   — nada de calcular posição a cada scroll. */
(function palcoFixoComSaida() {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;
  var media = raiz.querySelector('.pp26-product-grid__media');
  if (!media) return;

  raiz.classList.add('pdp26-palco-fixo');

  /* o que marca "acabou o produto": a primeira seção depois da PDP.
     Costuma ser o texto de SEO; se não houver, o rodapé serve. */
  /* o marco tem que ser a primeira seção REALMENTE depois do produto. Pegar
     "o próximo irmão com altura" apanhava blocos que ainda pertencem à PDP
     (recomendações, avaliações) e a obra saía de cena cedo demais — no meio
     da decisão de compra (4/ago, medido: sumia em y=1200 de 2400). O
     rodapé/SEO é o critério certo; o irmão só entra se nada disso existir. */
  /* o RODAPÉ de verdade, não o texto de SEO: o SEO começa a 55% da página e
     ainda fala do produto — tirar a obra ali é cedo demais. O .obrah-ft
     abre a 73%, quando o assunto virou atendimento e institucional. */
  var marco = document.querySelector('.obrah-ft')
           || document.querySelector('.shopify-section-group-footer-group')
           || document.querySelector('footer');
  if (!marco) {
    var secaoPdp = raiz.closest('.shopify-section') || raiz;
    var irmao = secaoPdp.nextElementSibling;
    while (irmao && !marco) {
      if (irmao.offsetHeight > 60) marco = irmao;
      irmao = irmao.nextElementSibling;
    }
  }
  if (!marco) return;

  /* IntersectionObserver sozinho não serve aqui: ele avisa quando o marco
     ENTRA e quando SAI, e "saiu" acontece nos dois extremos — antes de
     chegar e depois de passar. No fim da página o rodapé já tinha saído por
     cima, o observer dizia "não está visível" e a obra voltava, cobrindo o
     rodapé (4/ago, ao vivo). O que importa não é se o marco está visível, e
     sim se ele já subiu além da metade da tela: daí em diante o assunto
     deixou de ser o produto e a obra fica fora, ponto. */
  /* (4/ago) DOIS ESTADOS: a obra abre grande — é o primeiro contato, e é
     ela que a pessoa veio ver — e encolhe no primeiro scroll, quando o
     assunto vira escolher e comprar. Junto com o encolhimento saem o X e as
     ferramentas: eles pertencem ao momento de contemplar; depois só roubam
     atenção da coluna. Sobem de volta se a pessoa voltar ao topo. */
  var compacto = false;
  function decideCompacto() {
    var agora = window.scrollY > 40;
    if (agora !== compacto) {
      compacto = agora;
      raiz.classList.toggle('pdp26-compacto', agora);
      /* o QUADRO DENTRO DA CENA é posicionado pelo motor em pixels, contra o
         recorte atual da foto (cover). Quando o palco muda de altura a foto
         recorta diferente e o quadro fica com as coordenadas velhas — subia
         pra fora da cena ("o quadro vai lá pra cima"). O motor reposiciona
         no resize; UM aviso depois da transição assentar basta. Durante ela
         não: era a chuva de resizes que causava o lag de antes, e o
         reposicionamento do motor é seco — no meio do movimento viraria
         tranco. */
      clearTimeout(decideCompacto.__amb);
      decideCompacto.__amb = setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 500);
    }
  }

  /* ═══ A VISÃO INTEIRA ENCOLHE PRA CABER (4/ago) ═══
     Ideia do Rafael: em vez de redimensionar peças do motor, pega a visão
     ampliada como ela é e DIMINUI O CONJUNTO até caber no palco reduzido —
     as laterais sangram com o fundo cinza do próprio palco.

     O transform vai no TRILHO (.pp26-gallery__slider): a galeria não serve
     porque o arrasto do jun26 escreve translate3d inline nela e apagaria a
     escala no primeiro swipe; o slide não serve porque era o alvo do
     centraObra. O trilho ninguém toca.

     UM ANIMADOR SÓ (4/ago, "fica meio desengonçado"): a primeira versão
     corrigia por tentativas — media o que ficou, corrigia o resto, três
     passadas — enquanto o centraObra do motor escrevia posição no slide sem
     transição. Cada correção reiniciava a animação e cada disparo do motor
     era um tranco seco: o movimento saía em degraus. Agora o centraObra
     cede a vez no mobile (ver jun26.js) e o alvo daqui é RESOLVIDO DE UMA
     VEZ, por álgebra: os rects atuais + o transform atual permitem deduzir
     a geometria natural (sem transform) do trilho e da obra, e dela sai o
     par translateY/scale final para o estado que vem. Uma escrita, uma
     transição, nenhum degrau. As passadas de agendaEscala só reconfirmam o
     alvo — como ele dá sempre no mesmo número, não reiniciam nada. */
  /* ═══ A ESCALA DO COMPACTO É CSS PURO (4/ago, 5ª e última iteração) ═══
     Houve aqui um maquinário inteiro de medição: rects, álgebra pra desfazer
     transform, cache de geometria natural, calibração por offsets, vigia de
     reconstrução do DOM. Morreu tudo, e a lápide serve de aviso: o
     pp26-gallery RECONSTRÓI o trilho quando quer, o motor escreve transform
     onde quer, e qualquer valor medido em runtime pode ser colhido no
     instante errado — cada conserto abria um buraco novo (quadro cortado,
     perspectiva fantasma, dança).
     A resposta que sobrevive a tudo isso não mede nada: o compacto é a visão
     do palco grande INTEIRA, escalada pela razão exata das alturas
     (30vh/46vh), ancorada no topo — ver o CSS. Regra de classe não morre com
     nó reconstruído, não depende de instante de leitura e anima na
     composição. */

  /* a reconstrução do trilho (voltas de cena) desloca a obra; o corretor
     incremental do jun26 roda no resize. UM aviso por rajada de mutações,
     depois que o DOM assentou — nada por frame, nada durante transição. */
  try {
    var moTimer = null;
    var avisa = function () {
      /* com a máquina de troca no ar, espera ela terminar — disparar agora
         faria o corretor escrever no meio da coreografia dela */
      if (media.classList.contains('jun26-sl-drag')) { moTimer = setTimeout(avisa, 450); return; }
      window.dispatchEvent(new Event('resize'));
    };
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(avisa, 450);
    }).observe(media, { childList: true, subtree: true });
  } catch (e) {}

  var travado = false;
  function decide() {
    decideCompacto();
    var t = marco.getBoundingClientRect().top;
    /* some quando o rodapé encosta no topo da tela, não quando aparece:
       enquanto ele está subindo a obra ainda faz sentido ao lado */
    var fora = t < window.innerHeight * 0.15;
    if (fora !== travado) {
      travado = fora;
      raiz.classList.toggle('pdp26-palco-off', fora);
    }
  }
  var pendente = false;
  function agenda() {
    if (pendente) return;
    pendente = true;
    requestAnimationFrame(function () { pendente = false; decide(); });
  }
  window.addEventListener('scroll', agenda, { passive: true });
  window.addEventListener('resize', agenda);
  decide();
})();

/* ═══ RODA DO MOUSE — RECUADO (4/ago) ═════════════════════════════════════
   A roda sobre o palco chegou a trocar de cena, para dar no desktop o que o
   dedo faz no celular. Recuado no mesmo dia: quem rola a página passa o
   cursor sobre a obra no caminho, e a cena virava sozinha durante uma
   leitura que nem era sobre ela ("desk tá descendo no scroll e mudando de
   imagem"). Sequestrar a rolagem cobra um preço que só se paga quando não
   há outro caminho — e aqui há: as setas do palco já navegam no desktop,
   com alvo explícito e sem competir com o gesto mais usado da página. */
(function rodaTrocaCena() {
  return;   /* mantido desligado; ver a nota acima antes de reativar */
  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;

  function comPalco(cb) {
    if (window.__pdp26Amb) return cb(window.__pdp26Amb);
    raiz.addEventListener('pdp26:palco-pronto', function () { cb(window.__pdp26Amb); }, { once: true });
  }

  comPalco(function (palco) {
    if (!palco || !palco.envs || !palco.envs.length) return;
    var media = raiz.querySelector('.pp26-product-grid__media');
    if (!media) return;

    var SEQ = ['quadro'].concat(palco.envs.map(function (e) { return e.id; }));
    var ultimo = 0;
    var INTERVALO = 380;   /* ms entre trocas: um giro = uma cena */

    media.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < 4) return;
      var agora = Date.now();

      var i = SEQ.indexOf(typeof palco.modo === 'function' ? palco.modo() : 'quadro');
      var passo = e.deltaY > 0 ? 1 : -1;
      var alvo = i + passo;

      /* nas pontas a página volta a rolar: sem isso o palco vira uma
         armadilha da qual só se sai com a barra de rolagem */
      if (alvo < 0 || alvo >= SEQ.length) return;

      e.preventDefault();
      if (agora - ultimo < INTERVALO) return;
      ultimo = agora;
      palco.setMode(SEQ[alvo]);
    }, { passive: false });
  });
})();

/* ═══ APROVEITAMENTO DA MOLDURA NO DESKTOP (5/ago) ════════════════════════
   Auditoria por largura (pedido do Rafael): entre ~990 e ~1560px a obra
   afundava pra 34–59% do palco — o orçamento de altura (100vh) sobrava e a
   moldura ficava um selo. Faixas fixas de CSS não servem: a ocupação também
   depende da ALTURA da janela. Então mede-se e ajusta-se: escala no TRILHO
   (o nó que nem o arrasto nem o motor tocam), alvo de 75% da altura do
   palco, com dois tetos — nunca passar de 90% da largura da coluna e nunca
   reduzir (k ≥ 1: onde o motor já acerta, mão nenhuma). Roda na carga, no
   resize e na troca de variante; nunca durante uma transição. */
(function aproveitaMolduraDesktop() {
  var raiz = document.querySelector('.thb-product-detail--pdp2026');
  if (!raiz) return;
  var media = raiz.querySelector('.pp26-product-grid__media');
  if (!media) return;

  /* A TINTA, não a caixa (5/ago, pedido do Rafael: "primeiro e último pixel").
     A caixa da arte não é o objeto visual: a moldura tem a face 3D à direita
     (~14% da largura da arte, na perspectiva da casa) e a sombra respira à
     esquerda (~10%). Centrar e limitar pela TINTA ESTIMADA é o que impede o
     vazamento pra dentro da coluna. E uma passada corretiva confere as
     margens de verdade depois de aplicar. */
  var TINTA_ESQ = 0.10, TINTA_DIR = 0.14;

  /* (5/ago) O ENQUADRAMENTO NÃO SE ASSENTA EM PÚBLICO.
     Na abertura o cálculo roda várias vezes — o motor monta a moldura, a foto
     chega, a fonte troca — e cada passada movia a obra COM a transição do
     trilho ligada: a moldura ia e voltava na frente de quem abriu a página
     ("sambando na primeira abertura"). Enquanto a página assenta, o trilho
     aplica sem animar: quem chega vê a posição final, não o caminho até ela.
     Depois disso a transição volta, porque aí ela serve à troca de vista. */
  var assentando = true;
  setTimeout(function () { assentando = false; }, 3550);

  /* (5/ago) E NEM SEM ANIMAÇÃO PODE APARECER. Desligar a transição tirou o
     deslizamento, mas sobraram os SALTOS: a obra nascia num lugar, pulava
     para outro e voltava, porque cada passada do cálculo corrige a anterior
     ("abre assim... desce... e sobe de novo"). A correção não é acelerar o
     cálculo, é não ter plateia: o palco entra velado e só se revela com o
     enquadramento fechado. Teto de 2,6s — se algo travar, a obra aparece de
     qualquer jeito; velar para sempre seria pior que sambar. */
  var revelado = false, revTimer = null, congelado = false;
  var nasceu = Date.now();
  function revelar() {
    if (revelado) return;
    /* (6/ago) A REVELAÇÃO ESPERA A MOLDURA. O silêncio de 260ms media só o
       sossego do CÁLCULO — se o PNG da moldura ainda estava na rede, a obra
       era revelada e CONGELADA com o enquadre de um palco pela metade. Cada
       load abria numa altura diferente ("flutuando", 6/ago, medido: y=81 num
       load, 147 no outro). Enquadramento fechado inclui a imagem em casa;
       o teto de sempre segura o pior caso de rede. */
    if (Date.now() - nasceu < 3400) {
      var frv = media.querySelector('.pp26__frame');
      if (frv && !frv.complete) { revTimer = setTimeout(revelar, 200); return; }
    }
    revelado = true;
    congelado = true;   /* apareceu: acabou o direito de se mexer sozinho */
    clearTimeout(revTimer);
    raiz.classList.remove('pdp26-enquadrando');
  }
  /* (5/ago) DEPOIS DE APARECER, NINGUÉM MEXE. As passadas agendadas existem
     para o caso de a moldura montar tarde — e devem morrer no instante em que
     a obra fica visível. Um enquadramento levemente fora e PARADO é melhor do
     que um que se corrige na cara de quem está olhando. Só gesto de gente
     descongela: redimensionar a janela ou trocar de variante. */
  function descongelar() {
    congelado = false;
    clearTimeout(descongelar.__t);
    descongelar.__t = setTimeout(function () { congelado = revelado; }, 1400);
  }
  /* (5/ago) RELÓGIO DE SILÊNCIO. Revelar por tempo fixo ainda deixava passar
     uma correção tardia — a obra aparecia e DESCIA ("abre e desce"). Agora
     cada aplicação de transform adia a revelação; a obra só aparece depois de
     260ms sem ninguém mexer nela. Teto absoluto de 3s para o caso de o
     cálculo nunca sossegar: melhor uma obra que se ajusta do que nenhuma. */
  function adiarRevelacao() {
    if (revelado) return;
    clearTimeout(revTimer);
    revTimer = setTimeout(revelar, 260);
  }
  raiz.classList.add('pdp26-enquadrando');
  /* NÃO se arma o relógio aqui: armar antes da primeira conta revelava a obra
     em 260ms — antes de qualquer ajuste — e a partir daí tudo passava a ser
     animado, com a corretiva medindo no meio da viagem. Daí a oscilação que
     levava vinte passadas para assentar, toda ela à vista. O relógio começa a
     contar na PRIMEIRA aplicação; o teto de 3s cobre o caso de nunca haver uma. */
  setTimeout(revelar, 3600);

  /* (5/ago) O PÉ DO PALCO NÃO É PALCO. Os últimos ~116px são a régua de
     controles (toggle + setas + o respiro de 22px até a borda). O cálculo
     antigo usava a altura CHEIA como orçamento e centrava nela — resultado:
     a obra descia até a moldura passar por trás do toggle ("tá ficando em
     cima do quadro"). Aqui a faixa sai do orçamento E do centro. */
  var RODAPE = 116;

  function ajusta(corretiva) {
    var trilho = media.querySelector('.pp26-gallery__slider');
    /* (06/09) a textura só serve de medida quando está LIGADA: fora do canvas
       ela existe oculta, altura 0 — e o enquadrador desistia sem posicionar
       nada (PDP aberta direto em sem moldura: arte grande e à esquerda). */
    var obra = media.querySelector('.pp26__art-tex.is-on') || media.querySelector('.pp26__art');
    if (!trilho || !obra) return;
    /* fora do regime desktop: NUNCA deixar transform órfão — cruzar os
       990px com escala de desktop aplicada estourava o layout tablet
       (5/ago, "ele vaza") */
    if (!window.matchMedia('(min-width: 990px)').matches) {
      if (trilho.style.transform) trilho.style.transform = '';
      revelar();   /* fora do regime desktop não há o que enquadrar */
      return;
    }
    if (media.classList.contains('jun26-sl-drag')) return;
    if (congelado) return;

    var atual = 1, tx0 = 0, ty0 = 0;
    var mS = /scale\(([\d.]+)\)/.exec(trilho.style.transform || '');
    if (mS) atual = parseFloat(mS[1]) || 1;
    var mT = /translate\((-?[\d.]+)px, *(-?[\d.]+)px\)/.exec(trilho.style.transform || '');
    if (mT) { tx0 = parseFloat(mT[1]) || 0; ty0 = parseFloat(mT[2]) || 0; }
    else {
      var mX = /translateX\((-?[\d.]+)px\)/.exec(trilho.style.transform || '');
      if (mX) tx0 = parseFloat(mX[1]) || 0;
    }

    var rm = media.getBoundingClientRect();
    var ro = obra.getBoundingClientRect();
    if (!rm.height || !ro.height || ro.height < 40) return;   /* motor ainda montando */

    /* altura ÚTIL: até onde a obra pode descer sem passar por trás do toggle.
       (5/ago) A conta boa não é "palco menos 116px": o palco tem 100vh mas
       COMEÇA abaixo do header, então o pé dele cai fora da tela — e o toggle
       não mora no pé do palco, mora na dobra visível (fitaNaDobra). Medir o
       toggle de verdade é o único jeito que fecha nas duas visões. */
    var fita = document.querySelector('.pdp26-fita__chips');
    var hFita = fita ? fita.getBoundingClientRect().height : 0;
    /* posição ESTÁVEL da fita (22px do pé do palco), não a instantânea: na
       primeira dobra ela sobe junto com a parte escondida do palco, e ancorar
       na medida do momento fazia o enquadramento depender de onde a página
       estava quando o ajuste rodou. */
    /* e mais o quanto a fita SOBE na primeira dobra: enquanto o topo do palco
       está abaixo do header, fitaNaDobra levanta os controles exatamente essa
       altura para que não caiam fora da tela. Reservar o pior caso é o que
       impede a cena de encostar no toggle logo na abertura da página. */
    var hdr = document.querySelector('theme-header.header, .thb-header, #shopify-section-header');
    var hHdr = hdr ? hdr.getBoundingClientRect().height : 0;
    /* (5/ago) PISOS EM VEZ DE ESPERA. Tentar adiar o cálculo até fita e header
       existirem travava o ajuste inteiro quando o header se esconde (altura
       zero é um estado legítimo, não "ainda não montou"). Aqui a régua tem
       medidas mínimas conhecidas — 38px de fita, 44px de header — então a
       conta nunca superestima o orçamento, monte a página na ordem que montar. */
    var subida = Math.min(160, Math.max(44, hHdr, Math.max(0, rm.top)));
    var hUtil = Math.max(240, rm.height - (22 + Math.max(38, hFita) + 18) - subida);

    var hNat = ro.height / atual, wNat = ro.width / atual;
    var tintaW = wNat * (1 + TINTA_ESQ + TINTA_DIR);
    var k = Math.min((hUtil * 0.82) / hNat, (rm.width * 0.88) / tintaW);

    /* (5/ago) TETO PELA CENA INTEIRA, não só pela arte.
       Na PERSPECTIVA o objeto visual não é a arte: é o palco 3D, que carrega a
       face lateral da moldura e a sombra e chega a ser 35% maior que ela. O
       cálculo pela arte enxergava espaço que não existia e mandava um zoom que
       cortava a própria moldura — a "visão quebrada" em janelas de ~1000px.
       Aqui a cena entra inteira no orçamento, e é o menor dos dois que vale. */
    var cena = media.querySelector('.pp26__perspective-stage');
    var rc = cena ? cena.getBoundingClientRect() : null;
    var temCena = !!(rc && rc.width > 40 && rc.height > 40);

    /* RESPIRO: a sombra da moldura é desenhada FORA da caixa da cena. Encaixar
       a cena rente à borda cortava justamente a sombra (5/ago, "tá cortando
       parte da sombra na moldura"). 14px de margem morta dos quatro lados. */
    var F = 20;
    /* e a obra não fica no centro geométrico: desce um tico. Em cima a página
       tem peso (o header logo acima) e embaixo não tem nada — centrada no
       milímetro, a obra lê como alta. 20px devolvem o equilíbrio ÓPTICO. */
    var VIES_Y = 20;
    if (temCena) {
      k = Math.min(k,
        (rm.width - 2 * F) / (rc.width / atual),
        (hUtil - 2 * F) / (rc.height / atual));
    }
    /* (5/ago) O PISO DEIXA DE SER 1 QUANDO A CENA NÃO CABE. "Nunca reduzir"
       nasceu para não estragar as janelas em que o motor já acerta, mas em
       telas baixas a cena natural chega a ser mais alta que o palco menos a
       régua — e aí segurar k em 1 significa escolher entre cortar a moldura
       ou enfiá-la atrás do toggle. Encolher um pouco é a única resposta que
       não mente. 0.86 é o limite: abaixo disso a obra vira selo. */
    k = Math.max(temCena ? 0.86 : 1, Math.min(2.6, k));

    /* (5/ago) A CORREÇÃO MEXE NA POSIÇÃO, NUNCA MAIS NA ESCALA.
       Recalcular k a cada passada era instável por natureza: a moldura em
       perspectiva não escala linearmente (a face 3D e a sombra crescem em
       outro ritmo), então `altura / escala atual` nunca devolve o mesmo
       natural. O registro mostrou k subindo, passando do ponto e voltando —
       0.86 → 0.98 → 1.00 → 0.95 → 0.92 → 0.91… — cinco correções por passada,
       todas visíveis. Agora a escala é decidida uma vez e congela; as passadas
       seguintes só terminam de centrar, e isso converge sozinho. */
    if (corretiva) k = atual;

    /* CENTRAR PELA CENA quando ela existe. A tinta estimada era um remendo de
       quando só se tinha a caixa da arte: a face 3D e a sombra ficavam de fora
       da conta e a cena escapava pela esquerda, encostando na borda que a
       recorta. A cena é a caixa real do que se vê — centrar por ela acerta os
       dois lados de uma vez. */
    var ref = temCena ? rc : ro;
    var vies = temCena ? 0 : (TINTA_DIR - TINTA_ESQ) / 2 * ro.width;
    var desvio = (rm.left + rm.width / 2) - (ref.left + ref.width / 2 + vies);
    var tx = tx0 + desvio;
    /* e o centro VERTICAL é o da área útil, não o do palco cheio */
    var desvioY = (rm.top + hUtil / 2 + VIES_Y) - (ref.top + ref.height / 2);
    var ty = ty0 + desvioY;

    var alvo = (k > 1.02 || Math.abs(tx) > 3 || Math.abs(ty) > 3)
      ? 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px) scale(' + k.toFixed(3) + ')' : '';
    if ((trilho.style.transform || '') !== alvo) {
      trilho.style.transformOrigin = '50% 50%';
      /* enquanto a página assenta VELADA, salta direto para o valor final.
         Depois de revelada, qualquer correção volta a ser animada — um salto
         com a obra à vista é justamente o que não pode acontecer. */
      if (assentando && !revelado) {
        trilho.style.transition = 'none';
        trilho.style.transform = alvo;
        /* devolve a transição ao CSS quando o assentamento terminar */
        clearTimeout(ajusta.__tr);
        ajusta.__tr = setTimeout(function () {
          if (!assentando) trilho.style.transition = '';
        }, 3300);
      } else {
        trilho.style.transition = '';
        trilho.style.transform = alvo;
      }
      adiarRevelacao();   /* mexeu: a revelação espera o próximo silêncio */
    }
    /* passada corretiva: mede a tinta estimada JÁ aplicada e conserta
       margens — uma vez, nunca em cascata.
       (5/ago) Agora ela SEMPRE roda quando houve escala: com origem em 50% 50%
       o zoom é do TRILHO, não da obra — se a obra não estava no centro dele, a
       escala arrasta o centro dela junto e o enquadramento calculado antes
       deixa de valer. Era esse o descolamento que empurrava o pé da moldura
       para trás do toggle. */
    /* (5/ago) 420ms, não requestAnimationFrame: o trilho tem `transition: all`,
       então no quadro seguinte a obra ainda está VIAJANDO para a nova escala.
       A corretiva media o meio da animação e "corrigia" para um lugar que já
       não existia — por isso o pé nunca fechava. Aqui ela mede parado.
       Quatro passadas no máximo (5/ago): a escala é aplicada no mesmo gesto em
       que o centro é calculado, então cada rodada acerta parte do desvio e a
       seguinte acerta o resto. Duas não bastavam — sobravam ~30px no pé. */
    var passe = (corretiva || 0);
    if (passe < 6) setTimeout(function () {
      var rm2 = media.getBoundingClientRect();
      var r2 = temCena ? cena.getBoundingClientRect() : obra.getBoundingClientRect();
      var esq = temCena ? (r2.left - rm2.left) : ((r2.left - r2.width * TINTA_ESQ) - rm2.left);
      var dir = temCena ? (rm2.right - r2.right) : (rm2.right - (r2.right + r2.width * TINTA_DIR));
      var topo = r2.top - rm2.top;
      var pe = (rm2.top + hUtil) - r2.bottom;      /* folga até a régua do pé */
      /* (5/ago) e um critério de CENTRO, não só de folga mínima: sem ele a
         conferência dava por boa uma cena com 158px de um lado e 21 do outro
         — dentro do palco, mas torta. Agora ela também exige que os dois
         lados sejam parecidos. */
      var desalinho = Math.abs(esq - dir);
      if (esq < F - 2 || dir < F - 2 || topo < F - 2 || pe < F - 2 || desalinho > 12) ajusta(passe + 1);
      /* sem transição não há viagem para esperar: durante o assentamento a
         conferência é quase imediata, e a página converge antes de aparecer */
    }, assentando ? 60 : 420);
  }
  setTimeout(function () { ajusta(); }, 600);
  setTimeout(function () { ajusta(); }, 1400);
  /* (5/ago) e uma terceira, com o motor já assentado: em 700/1600ms a moldura
     ainda está sendo montada em algumas variantes, e o enquadramento nascia de
     uma medida provisória que ninguém revisava depois. */
  setTimeout(function () { ajusta(); }, 2200);
  setTimeout(function () { ajusta(); }, 3000);
  /* (5/ago) O ResizeObserver SAIU — ele era o laço.
     "Transform não dispara ResizeObserver" é verdade para um elemento comum,
     mas aqui o motor REDESENHA a moldura quando a escala muda: a obra muda de
     tamanho de verdade, o observer acorda, eu reajusto, o motor redesenha de
     novo. O registro mostrou vinte passadas oscilando (k 0.86 → 0.97 → 0.90 →
     0.91…) sem nunca sossegar — e a partir da revelação, tudo isso à vista.
     Sem ele, quem manda são as passadas agendadas e os gestos reais do
     usuário (redimensionar a janela, trocar de variante). */
  window.addEventListener('resize', function () {
    descongelar();
    clearTimeout(ajusta.__t);
    ajusta.__t = setTimeout(function () { ajusta(); }, 200);
  });
  /* semente do filtro de moldura: o valor que a página abre marcado */
  (function () {
    var o1 = raiz.querySelector('fieldset[data-index="option1"] input:checked');
    ajusta.__mold = o1 ? o1.value : '';
  })();
  raiz.addEventListener('change', function (ev) {
    /* (6/ago) TROCA DE COR/TAMANHO NÃO REENQUADRA — só moldura (option1).
       Medido ao vivo: os PNGs das quatro cores têm a moldura no MESMO lugar
       (bounds idênticos, repouso idêntico), e o tamanho não toca o palco.
       Ainda assim cada troca disparava o reenquadre: o trilho recebia um
       transform animado, o motor redesenhava, a fita acordava o centrador do
       jun26, e cada um media no meio da viagem do outro — a obra descia,
       subia além e ficava oscilando ±3px ("sambando", 6/ago). Sem geometria
       nova não há o que reenquadrar: cor troca em crossfade PARADO. */
    /* o filtro NÃO pode ser pelo alvo do evento: o variant-selects do tema
       re-emite o change a partir de si mesmo (sem fieldset ancestral) e o
       reenquadre voltava por essa porta. O critério é o ESTADO: só quando o
       valor de option1 realmente mudou desde a última vez. */
    var o1 = raiz.querySelector('fieldset[data-index="option1"] input:checked');
    var agora = o1 ? o1.value : '';
    if (agora === (ajusta.__mold || '')) return;
    ajusta.__mold = agora;
    /* (01/10) TROCA DE MOLDURA TAMBÉM NÃO REENQUADRA. O enquadre de cada tipo
       difere ~3% de escala e ~10px (medido: padrão 0.999, canvas 1.026); a
       passada de 900ms deslizava o trilho inteiro DEPOIS da troca — o segundo
       movimento, o "sambar entre molduras". Trilho parado na abertura enquadra
       todos (margens 30–48px, medido com ele travado). */
  }, true);
})();
